
export default [
       {
    id: 74,
    title: '忆伯科技便携式无人机识别肩灯开展上海公安学院战训二部设备调试',
    content:
      '近日，忆伯科技团队赴上海公安学院战训二部，围绕低空安防教学实训需求，开展便携式无人机识别肩灯的设备调试，并就设备在警务教学中的应用与院方进行深度交流。上海公安学院战训二部长期聚焦公安实战教学，将一线正在使用的低空感知装备引入教学环节，有助于学员在校期间熟悉低空安防操作流程，缩短从课堂到执勤岗位的适应过程。<p>' +
      '</p>' +
      '调试期间，忆伯科技团队逐一核验了肩灯的运行识别信号接收、声光与振动提示、状态指示等功能，并完成与配套移动端应用的联动测试。作为低空数字底座中的便携式形态，肩灯夹扣于肩袖或肩带，随人而动，将低空感知能力延伸至固定设施覆盖之外的一线勤务末端。<p>' +
      '</p>' +
      '从执勤一线到教学课堂，低空安防能力的落地离不开警企双向赋能。忆伯科技将持续深化与公安院校、科研机构的协同，以"空天地海一体化"为核心中枢，形成天基—地基—终端全链路协同的全域感知能力，以"快速响应，联勤联动"为准则，为低空安全人才培养与实战能力建设提供技术支撑。<p>' +
      '</p>' ,
    date: '2026.10.22',
    des: '忆伯科技团队赴上海公安学院战训二部就设备在警务教学中的应用进行交流。',
    cover: '/news/new74.png',
  },
       {
    id: 73,
    title: '忆伯科技亮相2026年上海市无线电主题市集走近市民',
    content:
      '在上海市无线电管理宣传月期间，“频谱无形 守护有道”2026年上海市无线电主题市集于9月17日至18日在普陀区中海真如环宇城举行。忆伯科技作为参展单位设立低空安全互动专区，通过沉浸式体验让市民“看得见、认得出”身边的无人机。<p>' +
      '</p>' +
      '现场设置佩戴体验、科普宣讲与亲子竞赛三大环节。市民可佩戴便携式无人机识别肩灯，配合终端模拟追踪无人机飞行轨迹，将低空安全风险转化为直观可感的画面；我司代表结合真实案例讲解违规飞行的安全隐患，并普及适飞空域、实名登记、飞行报备等合规要求；亲子“低空寻踪”趣味竞赛则引导家庭在游戏中建立安全意识。此外，我司现场演示了无人机“发现—定位—处置”全流程——相关装备仅负责识别与感知，现场处置由安保人员依法依规执行，完整呈现低空安全防护闭环。<p>' +
      '</p>' +
      '低空安全离不开社会共治。此次活动，忆伯科技以互动科普回应无线电管理宣传月主题，未来将持续推动技术能力与公众认知同向发力，让技术能力既服务监管，也惠及公众。<p>' +
      '</p>' ,
    date: '2026.09.21',
    des: '9月17日至18日，忆伯科技参加上海市无线电管理宣传月活动。',
    cover: '/news/new73.png',
  },
       {
    id: 72,
    title: '忆伯科技携便携式识别肩灯参加南京警察学院无人机反制培训实操',
    content:
      '9月15日，忆伯科技携低空数字底座产品参加南京警察学院无人机反制培训实操演示活动。培训期间，我司围绕装备配备、勤务应用与培训保障等方面，与各省参训人员开展深度交流。本次演示以主流无人机为目标机型，围绕识别与打击两类模式组织红蓝对抗，检验装备在贴近实战条件下的反应与协同能力。<p>' +
      '</p>' +
      '此次演示的有忆伯科技自主研发的便携式无人机识别肩灯（RR-P Lamp）为便携式低空感知终端，采用夹扣佩戴，通过蜂鸣、振动、灯光多维提示，便衣场景可切换至静音振动模式；可将已报备的作业航空器归入白名单，事件照常记录但不再重复告警。该设备配套移动端APP低空卫士可呈现无人机位置、高度与飞手位置等信息，适用于巡逻执勤、大型活动安保与应急处突等场景。同时，无人机运行识别地面站（RR-Vision）承担区域级固定布控，二者构成"点面互补"的低空感知网络，识别结果汇入低空有效监视平台，形成可追溯记录。<p>' +
      '</p>' +
      '未来，忆伯科技将持续配合各级公安机关开展装备培训与技术保障，以产品能力支撑基层实战，助力低空安全治理体系持续完善。<p>' +
      '</p>' ,
    date: '2026.09.17',
    des: '9月15日，忆伯科技参加南京警察学院无人机反制培训实操演示交流。',
    cover: '/news/new72.png',
  },
     {
    id: 71,
    title: '忆伯科技便携式无人机识别肩灯交付焦作市公安 助力一线低空安防能力升级',
    content:
      '为适应低空安防及无人机管控工作新形势，切实提升一线实战管控能力，8月20日下午，河南省焦作市公安局组织召开无人机侦测肩灯发放及使用教学专题会。<p>' +
      '</p>' +
      '会上，全体与会人员集中观看了专项教学短片，系统学习侦测肩灯的核心性能与操作规范，夯实理论基础。同时，现场完成设备统一配发，并组建工作交流群，推送操作资料，开展全覆盖实操演练，确保参训人员熟练掌握设备安装、APP调试、开机探测等全流程操作。会议强调，各单位要高度重视此次配发装备的实战应用和培训实效，切实将肩灯纳入日常巡逻与应急处置标准流程，做到人装结合、学以致用，为常态化无人机侦测、违规飞行处置筑牢基础。<p>' +
      '</p>' +
      '据悉，忆伯科技自主研发的无人机识别肩灯作为便携式低空感知终端，具备轻量化、易部署、机动灵活等特点，可有效弥补固定站覆盖盲区，在要地巡逻、大型活动安保、应急处突等场景中实现低空目标的快速发现与实时上报，是构建"固定+移动"互补型低空感知网络的关键一环。<p>' +
      '</p>' +
      '未来，忆伯科技将持续配合全国各地公安机关开展装备培训与技术保障，以产品能力赋能基层实战，助力低空安全治理体系不断完善。<p>' +
      '</p>',
    date: '2026.08.26',
    des: '8月20日，焦作市公安局召开无人机侦测肩灯教学专题会。',
    cover: '/news/new71.png',
  },
    {
    id: 70,
    title: '2026国际低空经济博览会在沪启幕，忆伯科技以“数字底座”解锁低空安全新可能',
    content:
      '7月22日至25日，2026国际低空经济博览会在国家会展中心（上海）盛大启幕。本届博览会以“驭低空新势，启经济新篇”为主题，展览总面积达6万平方米，汇聚400余家国内外参展企业，同期举办80余场高端论坛与多元互动活动。作为上海本土低空安全数字化治理领域的代表企业，忆伯科技携低空数字底座方案及全系列产品矩阵亮相大会。<p>' +
  
      '</p>' +
         '<h3>'+ '上海低空经济：从政策先行到产业集聚' + '</h3><p>' +
      '</p>' +
      '低空经济已连续三年写入政府工作报告，2026年《政府工作报告》更是首次将低空经济明确为新兴支柱产业。上海在这一领域的布局尤为密集：2026年2月1日，《上海市民用无人驾驶航空器飞行安全管理暂行办法》正式施行，同时由市交通委、市公安局、市数据局等多部门联合推出的“五个一”体系及配套措施同步落地运行；2月1日，“上海市低空飞行综合监管服务平台”同步上线，用户通过“随申办”即可一站式完成无人机登记与飞行申报；到2028年，上海低空经济核心产业规模目标达800亿元。<p>' +
      '</p>' +
         '<h3>'+ '低空安全：产业起飞前的“必答题”' + '</h3><p>' +
      '</p>' +
      '低空经济越是加速，安全底座越要扎实。作为扎根上海近十年的本土企业，忆伯科技深耕无人机运行识别与低空安全数字化治理领域，以“空天地海一体”为业务方向，为公安机关及政府部门提供全面、多样的低空安全解决方案。<p>' +
      '</p>' +
      '本次展会期间，忆伯科技重点展示低空数字底座方案——专为城市级低空安全监管打造的综合性数字化平台，由地面站识别系列、便携式识别系列、空天地海一体化系列、运行识别发射模块系列四大产品矩阵共同支撑。方案严格遵循GB46750-2025《民用无人驾驶航空器系统运行识别规范》强制国标，聚焦无人机黑飞预警、政务系统管理、机库事件巡查三大板块，支持空域管理、飞行服务、应急协同及自动化巡检闭环。<p>' +
      '</p>' +
      '其中，便携式无人机识别肩灯作为便携式识别系列的热销产品在展会期间备受欢迎。执勤人员开启佩戴该设备后，即可在巡逻过程中实时监视周边无人机运行识别信号，同步移动端“低空卫士”APP和低空数字底座平台，详细展示该无人机的经纬度位置、速度、高度、飞手位置、识别号等关键数据作为执法依据，大大提高现场处置的时效性与响应速度。<p>' +
      '</p>' +
      '另一款备受关注的展品是忆伯科技自主研发的苍蓝忆识Lite。该设备可在屏幕上实时展现无人机型号、真实高度、识别通道及频谱分析结果。不仅具备运行识别信号接收能力，更在此基础上增加了实时频谱扫描与协议解析功能，无论无人机采用运行识别广播，还是O3、O4图传系统，苍蓝忆识Lite都能实现对低空空域的有效发现与识别。设备支持腰挂与手持两种佩戴方式，灵活适配巡逻、安保、应急等多种场景，真正做到“随行侦测、即时研判”。<p>' +
      '</p>' +
      '而无人机运行识别地面站是专为接收无人机运行识别信号而设计的固定式接收设备，目前已在多省份实现规模化部署。单套设备覆盖半径超5公里，累计覆盖面积近3000平方公里。地面站同步接入低空数字底座平台，实时捕获无人机的电子牌照、位置、速度、高度及飞手位置等关键信息，全天候持续监视低空空域。秉持“事前感知、全域监视、数据留存”的主动管制理念，系统能够在第一时间识别异常飞行行为，为低空安全管理提供及时、准确、可追溯的数据支撑，有效赋能一线执法与应急响应。<p>' +
  
      '</p>' +
         '<h3>'+ '扎根上海，服务全国，走向世界' + '</h3><p>' +
      '</p>' +

       '从参与《民用无人驾驶航空器系统身份识别 地面接收设备通用规范》国家标准研制，到联合多地公安共建低空管控创新中心，忆伯科技始终以技术实践反哺行业标准建设。立足上海这片低空经济的热土，公司将持续深耕低空数字底座能力，以自主可控的技术体系为城市低空安全保驾护航，助力上海加快迈向具有国际影响力的低空经济产业高地，以数字底座护航城市低空安全发展新篇章。<p>' +
      '</p>',
    date: '2026.07.24',
    des: '7月22日至25日，忆伯科技亮相2026国际低空经济博览会。',
    cover: '/news/new70.png',
  },
   {
    id: 69,
    title: '忆伯科技出席《民用无人驾驶航空器系统身份识别地面接收设备通用规范》国家标准研制启动会',
    content:
      '7月16日，《民用无人驾驶航空器系统身份识别 地面接收设备通用规范》国家标准研制启动会在苏州工业园区成功召开。会议由中国电子技术标准化研究院华东分院举办，来自全国40家单位的50名专家参会。忆伯科技应邀出席，积极参与标准草案研讨。<p>' +
      '</p>' +
      '会上，中国电子技术标准化研究院物联网研究中心低空经济研究室主任宋继伟介绍了低空装备标准化发展现状，并对低空供给与安全相关政策进行了深度解读。来自高校、科研院所及行业企业的专家围绕标准草案关键技术要求、参数指标等进行了深入研讨。<p>' +
      '</p>' +
      '忆伯科技结合公司在无人机身份识别地面接收设备领域的多年研发积累与全国多地公安系统规模化部署的实战经验，围绕信号解码、信息安全、设备环境适配性等关键技术指标提出了建设性意见，为后续检测认证及规模化应用提供清晰依据。<p>' +
      '</p>' +
      '未来，忆伯科技将持续深耕低空安全数字化治理领域，积极参与国家及行业标准研制，以技术实践反哺标准建设，助力构建统一、规范、可落地的低空安全监管标准体系，为低空经济高质量发展贡献企业力量。<p>' +
      '</p>',
    date: '2026.07.17',
    des: '7月16日，忆伯科技受邀出席国家标准研制启动会。',
    cover: '/news/new69.png',
  },
    {
    id: 68,
    title: '忆伯科技受邀为南京警察学院首期低空安全与执法进修班授课',
    content:
      '近日，南京警察学院第一期“低空安全与执法”进修班圆满落幕。作为国内低空安全数字化治理领域的领先企业，忆伯科技受邀参与此次培训，为来自全国各省市公安系统及公安院校的低空安全业务骨干开展专题授课与实操指导。<p>' +
      '</p>' +
      '本次培训围绕低空安全前沿理论、反制技术与执法实践设置了三大模块。在“反制技术与设备实操”模块，进修班联合十余家优秀无人机反制企业开展全流程设备实训。忆伯科技代表携低空数字底座核心产品与解决方案亮相实训现场，结合公司在180余场重大活动低空安保中所积累的实战经验，深入剖析了无人机案件查处中的常见难点与应对策略。学员们通过“红蓝对抗”形式，在模拟场景中实际操作设备完成目标侦测、飞手定位、数据回传等全流程演练，有效提升了自身在低空安全执法领域的专业能力。<p>' +
      '</p>' +
      '自2025年以来，忆伯科技低空数字底座已在全国超过27个省市实现规模化落地应用，全面覆盖重大活动安保、城市日常巡逻、突发事件快速响应等核心工作场景。未来，忆伯科技将继续深化与监管部门的合作，推动技术研发与一线需求精准对接，持续赋能全国低空安全执法能力提升，为筑牢低空安全防线、护航低空经济高质量发展贡献企业力量。<p>' +
      '</p>',
    date: '2026.06.17',
    des: '忆伯科技受邀为低空安全业务骨干开展专题授课与实操指导。',
    cover: '/news/new68.png',
  },
  {
    id: 67,
    title: '忆伯科技出席低空无线电频谱安全专委会2026年度会员大会',
    content:
      '5月22日，以“无线创新 赋能无限”为主题的低空无线电频谱安全专业委员会2026年度会员大会，在上海市无线电监测站金桥实验室顺利召开。忆伯科技作为低空无线电监视技术行业的一员，受邀出席本次大会，与来自研发生产、科研院所、应用机构等领域的五十余家单位代表共襄盛举，共绘低空无线电频谱安全与低空经济发展的新蓝图。<p>' +
      '</p>' +
      '本次大会全面总结了专委会成立一周年的工作成效，发布了2026年度重点任务，围绕低空无线电频谱使用、实效发射试验、无人机及无人机反制设备管理等政策内容进行了专题解读，正式发布了无人机多维频谱地图测绘技术、低空无线电实效发射测试场建设指南等关键成果，进一步明确了新阶段上海低空无线电频谱安全领域的发展重点与实施路径。<p>' +
      '</p>' +
      '忆伯科技始终专注于低空无线电监视技术的自主研发与行业深耕，致力于为政府决策中枢、直管部门、企事业单位提供全场景技术支持，形成天基-地基-终端全链路协同的全域感知能力。会上，我司依托在频谱感知、数据融合及智能监视领域的持续创新，同与会专家及行业代表围绕低空飞行安全保障中的痛点与难点展开了深入探讨，积极响应并践行了从“被动应对”向“主动防御与技术攻关”转变的监管保障新思路。<p>' +
      '</p>' +
      '立足“十五五”开局新起点，忆伯科技将继续以技术为驱动，致力于为深度参与专委会各项工作，协同产业链伙伴推动“出题”与“答题”精准对接，在技术创新、安全防控、生态共建上实现新突破，为上海乃至全国低空经济的高质量发展筑牢频谱安全底座，贡献专业力量。<p>' +
      '</p>',
    date: '2026.05.25',
    des: '5月22日，忆伯科技出席低空无线电频谱安全专业委员会大会。',
    cover: '/news/new67.png',
  },
  {
    id: 66,
    title: '忆伯科技亮相2026深圳无人机展，便携式系列新品重磅首发',
    content:
     '5月21日，2026第十届世界无人机大会暨UASE无人机展在深圳隆重举行。忆伯科技携苍蓝忆识Lite、外挂式运行识别接收机等便携式系列新品首次公开亮相，以多形态阵容全面覆盖多元应用场景，全方位展示“空天地海”一体化监管方案成果，成为展会现场备受瞩目的焦点之一。<p>' +
'</p>' +
'本届展会的主题为“低空经济 飞向未来”，汇聚了17个国家和地区的1220家无人机及低空经济相关企业，吸引了预计20多万名观众与全球专业买家，构建起覆盖全产业链的展示生态，全方位呈现低空经济领域的技术创新成果与产业发展态势。<p>' +
'</p>' +
'新品领航：便携式系列产品首次亮相<p>' +
'</p>' +
'本次展会上，忆伯科技重磅推出的苍蓝忆识Lite与外挂式运行识别接收机，专为一线执勤场景量身打造，集轻量化、智能化与精准监视能力于一身，一经亮相便吸引了众多国内外专业观众与行业同行驻足交流，并与到场客户达成了初步合作意向。' +
'</p>' +
'苍蓝忆识Lite作为一款腰挂/手持式便携式接收设备，依托精准的监视与解析能力，帮助一线执勤人员快速锁定无人机与飞手位置，将监视数据高效转化为执法依据，大幅提升现场处置效率与准确性，灵活部署多种复杂环境中。外挂式运行识别接收机同样备受关注。该产品适配不同无人机类型及应用场景，实现多位置快速响应无人机事件，实时更新对无人机电子牌照、位置、高度、飞手信息等的实时记录，有力提升民航、通航等重点区域的安全性。<p>' +
'</p>' +
'忆伯科技作为专业的低空数字监管解决方案商，致力于为国家、政府及直管部门有效解决无人机黑飞及城市治理中响应滞后的现实难题。通过构建覆盖低空监管、警务实战与无人机作业等多元场景的一体化架构，深度融合了无人机运行识别地面站、苍蓝忆识4PRO、便携式无人机识别肩灯、苍蓝忆识Lite等部署设备的实时感知数据能力，推动低空监管从“碎片化响应”向“一体化治理”跃升，切实助力城市低空经济实现“飞得起来、管得住、用得好”。<p>' +
'</p>' +
'政策赋能：对标国标，破解低空监管难题<p>' +
'</p>' +
'<p>值得关注的是，2026年5月1日，《民用无人驾驶航空器系统运行识别规范》（GB 46750-2025）正式执行。该标准适用于微型、轻型、小型、中型、大型无人驾驶航空器，标志着我国无人机运行识别迈入标准化、规范化的新阶段。' +
'</p>' +
'<p>忆伯科技本次推出的新品方案严格遵循该强制国标，聚焦无人机滥用、黑飞及未经授权操作等问题。凭借多年在无线电有效监视技术领域的研发经验，已为全国80多个省市政府决策中枢、直管部门、企事业单位打造以无人机运行识别、ADS-B、AIS等核心技术为核心的收发设备及解决方案，并广泛应用于低空管制、智慧警务、智慧城市以及航海航天等多个领域。<p>' +
'</p>' +
'<p>未来可期：加速规模应用，打造低空数字底座' +
'</p>' +
'面向2026年，忆伯科技将以更坚定的步伐，加速推动解决方案在重点城市、关键基础设施及重大活动保障中的规模化落地与实战应用。公司将持续深化与公安、民航、通航等核心用户的协同创新，围绕“更轻便、更智能、更融合”的技术主轴，推动产品体系向精准化、平台化、生态化方向持续升级，全面打造具备国际竞争力的低空数字底座。' +
'</p>',
    date: '2026.05.22',
    des: '5月21日至23日，忆伯科技亮相2026第十届世界无人机大会。',
    cover: '/news/new66.png',
  },
  {
    id: 65,
    title: '忆伯科技出席慕尼黑上海电子生产设备展圆桌论坛',
    content:
      '3月25日，2026首届长三角低空产业科技金融大会暨电子智造助力低空经济高质量发展大会在慕尼黑上海电子生产设备展上隆重召开。本次大会汇聚政、企、学、研、金各界精英，以“电子智造助力低空经济高质量发展”为主题，搭建深度交流与资源对接平台，共探长三角低空经济与电子智造融合发展新路径，为低空经济这一国家新兴支柱产业夯电子基础、培发展新动能。<p>' +
      '</p>' +
      '忆伯科技出席“低空经济催生电子智能制造新赛道”主题论坛活动。随着低空经济的蓬勃发展，其对高性能、高可靠性电子产品的需求日益迫切，正成为驱动电子制造产业转型升级的重要力量。会上，忆伯科技代表与行业专家、企业代表齐聚一堂，分享了我司在无人机运行识别领域的前瞻洞察与技术积淀，深入探讨了低空经济浪潮下电子产品的需求与机遇，共同为低空经济与电子智造的深度融合凝聚共识、汇聚思路。<p>' +
      '</p>' +
      '未来，忆伯科技将继续以技术创新为驱动，持续赋能电子制造业的高端化、智能化、绿色化发展，助力产业在融合发展中迈向更高台阶。<p>' +
      '</p>',
    date: '2026.03.26',
    des: '3月25日，忆伯科技参加“低空经济催生电子智能制造新赛道”主题论坛活动。',
    cover: '/news/new65.png',
  },
  {
    id: 64,
    title: '喜报！忆伯科技获批2025年上海市专精特新中小企业',
    content:
      '近日，上海市经济和信息化委员会发布2025年上海市专精特新中小企业（第四批）名单，忆伯科技凭借在低空管控等领域的专业精研与硬核创新实力顺利通过复审并成功获批。这是对我司始终坚守“专精特新”发展道路、迈向高质量发展的充分肯定。<p>' +
      '</p>' +
      '我司将以专业铸品质、以创新谋发展，持续深耕低空安全治理前沿，聚力提升核心竞争力，充分发挥专精特新企业的示范引领作用，为上海培育新质生产力、推动中小企业高质量发展贡献企业力量。<p>' +
      '</p>',
    date: '2026.03.25',
    des: '忆伯科技上榜2025年上海市专精特新中小企业（第四批）名单。',
    cover: '/news/new64.png',
  },
  {
    id: 63,
    title: '忆伯科技肩灯助力保障莆超邀请赛、莆田湄洲跨年祈福盛典低空安全',
    content:
      '在2026年元旦到来之际，忆伯科技与莆田公安紧密协作，顺利完成了两场大型活动的低空安保工作。12月6日，“海安之夜·莆超邀请赛”在莆田市体育中心田径场圆满收官，最终常州队以3比1战胜莆田队；12月31日，2026湄洲妈祖祖庙跨年祈福盛典在湄洲岛燃情开唱，苏见信、陈志朋、李翊君等两岸知名歌手精彩献唱，众多观众在祥和喜庆的氛围中共同迎接新年曙光。<p>' +
      '</p>' +
      '莆田公安为筑牢低空防线，在活动前提前发布临时管制通告，构建“人防+技防协同”的立体安防体系，将场馆中心以及周边划定为低空严格管理区，全面部署了忆伯科技便携式无人机识别肩灯。一线民警们佩戴肩灯沿着活动关键点位巡逻，构建全域覆盖的低空监测网络，有效防范无人机 “黑飞” 带来的安全风险。<p>' +
      '</p>' +
      '从场景安全到空域治理，低空管控正成为我国空域规范化管理与智能化升级不可替代的战略支点。忆伯科技将持续钻研全域管控技术，推动低空安全从防御向治理转变，提升管控效能，维护城市低空的安全秩序。<p>' +
      '</p>',
    date: '2026.01.15',
    des: '12月，忆伯科技协助莆田公安保障两场大型活动低空安保工作。',
    cover: '/news/new63.png',
  },
  {
    id: 62,
    title: '喜报！忆伯科技荣获“2025中国无人机卓越技术创新奖”',
    content:
      '1月8日，由深圳市无人机行业协会、世界无人机大会组委会主办，在全国无人机协会合作互助平台、深圳市中安无人系统研究院、粤港澳大湾区低空经济研究院的支持下，2026全国无人机界迎春团拜会暨第十届无人机百人会在深圳世界之窗恺撒宫隆重举行，与近千名行业翘楚、十余个国家代表共同感知低空经济的发展蓝图。忆伯科技受邀出席本次盛会，并在颁奖盛典上荣获“2025中国无人机卓越技术创新奖”，彰显了协会与行业对我司综合实力与技术突破的高度认可。<p>' +
      '</p>' +
      '在全球低空经济从概念迈向规模化运营的关键阶段，我司始终以核心技术自主化作为发展根基，在低空管制、智慧警务以及航海航天等关键领域积累多项自主专利，构建起兼具开放性与扩展性的技术体系，旨在打造全域监管解决方案，已在智慧城市、应急救援等多场景实现规模化落地，有效破解行业痛点。<p>' +
      '</p>' +
      '会上，杨金才会长表示，低空经济为无人机行业发展带来了前所未有的发展机遇。当前，全球化秩序正进入新的调整阶段，人工智能技术与生产生活深度融合，无人机将加速推动行业应用创新。党的二十大描绘了以中国式现代化全面推进中华民族伟大复兴的宏伟蓝图，中国经济正由高速增长向高质量发展转变，这将为无人机行业创造更多的战略机遇。<p>' +
      '</p>' +
      '未来，我司将以此次获奖为契机，持续深化技术创新与场景融合，与行业同仁携手推动低空经济高质量发展，为打造更智能、更安全的低空生态贡献核心力量。<p>' +
      '</p>',
    date: '2026.01.12',
    des: '1月8日，忆伯科技受邀出席2026全国无人机界迎春团拜会。',
    cover: '/news/new62.png',
  },
  {
    id: 61,
    title: '忆伯科技星载ADS-B在轨稳定运行一周年',
    content:
      '2024年9月24日，由忆伯科技研制的宇航级ADS-B接收机，于山东海阳东方航天港由捷龙三号运载火箭成功送入太空。进入预定轨道以来，已在轨稳定运行一年有余，各项参数表现优异。该载荷凭借其高可靠与卓越稳定的性能，已稳定累积海量航空ADS-B数据。这些宝贵数据，既是提升全球空域监测与我国空域管理现代化水平的坚实数据基石，也为我国拓展太空态势感知、航空目标监视等前沿能力，奠定了关键的能力基础。<p>' +
      '</p>' +
      '该载荷以广阔的“天基视野”为钥，开启了全球空域持续感知的新维度。其超预期的在轨表现与可靠性，成功铸就了全天候、无缝航空追踪的能力基石，标志着“空天地海”一体化监管网络已完成关键验证，正从宏伟蓝图加速转化为现实能力。<p>' +
      '</p>' +
      '在此，我们谨以最崇高的敬意，感谢党和国家航天战略的远见引领；以最诚挚的谢意，致敬航天科技集团在工程实践中的鼎力协同；由衷的感谢忆伯科技与全体参研人员的创新智慧与无悔攻坚。正是这众志成城的合力，成就了这项广域持续感知的标志性成果。<p>' +
      '</p>' +
      '展望未来，忆伯科技必将以此为新的起点，继续躬耕寰宇、勠力同心，为构建完整、智能、一体化的“空天地海”监管体系贡献核心力量，在服务国家战略与探索星辰的征程中，坚定履行我们的时代使命与担当。<p>' +
      '</p>',
    date: '2026.01.07',
    des: '忆伯科技研制的宇航级ADS-B接收机已在轨稳定运行一年有余。',
    cover: '/news/new61.png',
  },
  {
    id: 60,
    title: '上海前滩音乐节热力开唱！忆伯科技肩灯协助治理无人机“黑飞”',
    content:
      '12月7日，“上海前滩（纷玩岛）音乐节”在浦东前滩体育公园举办，忆伯科技便携式无人机识别肩灯协助浦东警方共同构建“空地一体”防控体系，将无人机“黑飞”风险拦截在萌芽阶段。<p>' +
      '</p>' +
      '活动期间，警用无人机升空开展“空中巡逻”，地面反制阵地与民警配备的肩灯形成立体防控网。其中，忆伯科技肩灯具备实时捕捉违规飞行的RID信号功能，侦测包括无人机的唯一识别号、经纬度位置、飞行轨迹、飞手位置等无人机信息。核心管制区域实现无人机“零起飞、零扰序”，为大型户外活动低空安保提供了实战案例。<p>' +
      '</p>' +
      '8月以来，上海警方通过科技赋能、空地联动、综合施策，深入开展无人机“黑飞”整治行动。忆伯科技作为低空管控解决方案商，紧跟国家政策标准的步伐，将持续完善无人机从源头准入到飞行轨迹的全链路管控机制，为城市低空经济高质量发展构建坚实的数字安全防线。<p>' +
      '</p>',
    date: '2025.12.24',
    des: '12月7日，忆伯科技助力浦东警方防护上海前滩（纷玩岛）音乐节低空安全。',
    cover: '/news/new60.png',
  },
  {
    id: 59,
    title: '忆伯科技获评国家无线电监测中心2025无人机创新应用大会优秀项目成果',
    content:
      '11月21日，由国家无线电监测中心、湖南省工业和信息化厅、株洲市人民政府主办的2025无人机创新应用大会在湖南省株洲市举办。会上发布了92个优秀无人机和无人机探测防御领域成果清单，忆伯科技“便携式无人机识别肩灯”项目入选2025无人机创新应用大会优秀项目成果。<p>' +
      '</p>' +
      '本项目根据一线直管实战需求，通过无线电监测技术，能够实时锁定无人机的位置、飞行轨迹和飞手位置等信息，可在配套APP上直接导航至飞手位置，有效推动了监管模式从“事后追溯”向“实时预警”升级，为国家低空安全管理从源头上阻断“黑飞”危害。<p>' +
      '</p>' +
      '当前，低空经济作为党和国家高度重视的战略性新兴产业，是推动技术创新、产业升级和经济增长的新引擎。忆伯科技作为低空行业中的一员，将深度探索无人机创新应用的新路径、新模式，因地制宜地为重大活动保障、日常巡逻、城市安全等应用场景提供技术支撑，助力低空经济等战略性新兴产业健康有序发展。<p>' +
      '</p>',
    date: '2025.12.19',
    des: '忆伯科技项目入选2025无人机创新应用大会优秀项目成果。',
    cover: '/news/new59.png',
  },
  {
    id: 58,
    title: '忆伯科技无人机识别肩灯守护十五全运会',
    content:
      '在11月举行的第十五届全国运动会期间，忆伯科技自主研发的便携式无人机识别肩灯全面投入低空防护工作，为赛事的平安举办筑起一道安全屏障。<p>' +
      '</p>' +
      '作为低空安防的重要技术支撑，肩灯搭载于警用机器狗巡逻设备上，在活动现场实时监测空中动态。一旦识别到未经授权的无人机“黑飞”行为，肩灯即刻启动预警机制，通过声光闪烁提醒执勤人员，并将目标无人机及其飞手的位置信息迅速传输至移动端低空卫士APP，实现快速响应与精准处置。<p>' +
      '</p>' +
      '忆伯科技将持续助力建设国内低空安全体系，为智慧低空管理应用场景赋能，推动低空安全管理向数字化、智能化、精细化发展。<p>' +
      '</p>',
    date: '2025.12.10',
    des: '第十五届全国运动会期间，忆伯科技自研肩灯全面投入低空防护工作。',
    cover: '/news/new58.png',
  },
  {
    id: 57,
    title: '忆伯科技亮相第二十二届“上海之帆”经贸巡展匈牙利展、奥地利展',
    content:
      '10月30日至11月4日，第二十一届、第二十二届“上海之帆”经贸（人文）巡展在匈牙利布达佩斯和奥地利维也纳相继圆满落幕。忆伯科技应邀参展，携低空管制、船舶监管等创新方案与核心成果精彩亮相，与全球企业共探合作新机遇。<p>' +
      '</p>' +
      '作为上海近年来规模最大的境外自办展之一，本届巡展由上海市政协对外友好委员会指导，上海市工业经济联合会（市经团联）、上海现代服务业联合会、上海公共外交协会联合主办联合主办，获得了匈牙利权威机构与奥地利权威机构的鼎力支持，汇聚全球创新力量，聚焦高端制造、绿色科技与数字经济发展新趋势，共吸引了超过8000人次到场参观洽谈。<p>' +
      '</p>' +
      '展会期间，忆伯科技通过积极参与参与专题活动及百余场次产业对接会，与匈牙利、奥地利及多国企业代表、行业专家深入交流。凭借前沿的技术成果持续吸引专业观众驻足互动，成功达成多项合作意向，并建立起长效沟通机制与跨国协作通道。现场重点展示了我司在低空管制领域的解决方案，通过部署远程识别地面站、无人机识别肩灯等自主研发设备，联动低空有效监视管理平台，解决无人机滥用、黑飞等问题。同时，船舶监管海上联动搜救方案以其高效协同与实战应用能力为优势，为海上航行安全提供了有力保障，赢得广泛关注与认可。<p>' +
      '</p>' +
      '本次巡展不仅是技术方案的集中亮相，更是我司主动融入全球创新链、价值链的重要实践。未来，忆伯科技将以科技为桥、以合作为舟，在深耕全域数字底座的道路上稳步前行，以更宽广的国际视野，为推动中外经贸合作与技术交流贡献更多力量。<p>' +
      '</p>',
    date: '2025.11.13',
    des: '10月30日至11月4日，忆伯科技应邀参加“上海之帆”经贸巡展。',
    cover: '/news/new57.png',
  },
  {
    id: 56,
    title: '忆伯科技参加安徽省2025反恐应急装备展',
    content:
      '10月29日，由省公安厅警务保障部主办、阜阳市公安局承办的安徽省2025反恐应急装备展隆重开幕。忆伯科技携多款自主研发的实战化装备应邀参展，全面展示我司在智能安防与警用装备技术领域的技术创新与落地能力，获得现场公安领导及行业专家的高度关注。<p>' +
      '</p>' +
      '本次展会忆伯科技重点呈现了低空无线电侦测解析地面站、便携式无人机识别肩灯、无人机远程识别发射模块等设备，旨在构建起“空—地—人”立体化全域管控网络。其中，低空无线电侦测解析地面站具备高集成度、快速部署与多源数据融合能力，可实现对复杂环境下的实时态势感知；便携式无人机识别肩灯集实时定位与声光报警功能于一体，精准定位无人机与飞手位置，轻量化设计便于执行一线任务佩戴，已在全国多地大型安保活动完成实战验证，增强了执勤人员在突发事件处置中的主动防控能力，为城市空域安全提供全天候守护。<p>' +
      '</p>' +
      '忆伯科技始终聚焦一线警务需求，将继续深化警用装备智能化布局，系统推进多场景数字底座建设，通过打通数据壁垒、优化资源配置，全力筑牢城市警务全域转型的坚实基础，为提升警务效能、守护城市安全提供有力支撑，助力构建现代化社会治安防控机制。<p>' +
      '</p>',
    date: '2025.11.05',
    des: '10月29日，忆伯科技携多款自主研发的警用实战化装备应邀参展。',
    cover: '/news/new56.png',
  },
  {
    id: 55,
    title: '守护万千旅客出行安全：忆伯科技助力构建铁路低空监管新格局',
    content:
      '近年来，铁路沿线的无人机发生了多起坠落损害铁路设施、影响铁路运行的重大事件，极大威胁了铁路交通安全问题。值得关注的是，无人机安全管理有关法律法规、制度标准、管控技术等还在起步建设阶段，各相关管理部门、单位、企业之间还未形成协同高效的联动管理机制，导致对铁路沿线无人机飞行的监管陷入"看得见的管不着，管得着的看不见"的困境。<p>' +
      '</p>' +
      '为筑牢铁路运输安全的坚固防线，忆伯科技高度关注铁路对沿线无人机安全管理的需求，在接到某市级铁路公安部门关于强化区域铁路沿线无人机监管的工作要求后，迅速响应、积极对接，展开了多维度、深层次的战略合作，共抓获5起无人机侵限案件、1起危害电气化铁路设施案，为打造平安铁路提供了坚实保障。<p>' +
      '</p>' +
      '通过整合我司在无人机远程识别、空域监测等领域的技术积累，结合铁路公安在铁路治安管理、执法实践中的丰富经验，共同探索贴合实际需求的铁路沿线无人机安全管控路径，力求以技术赋能监管，以协同提升效能。基于对该区域铁路线路密集、周边环境复杂、无人机飞行风险点多等特点的共同研判，在铁路沿线关键节点部署无人机远程识别地面站，为该区域铁路运输安全构建全方位、立体化的防护网络。<p>' +
      '</p>' +
      '某市铁路公安将技术手段与实践执行深度融合，以"全程可视、轨迹可溯、责任可追"为目标，建立全流程响应机制：当监测到无人机违规进入铁路禁飞区时，直管人员可通过低空有限监视管理管理平台同步该无人机的动态飞行数据，精准呈现无人机事件的上下线时间，锁定该无人机的实时位置、飞手位置、唯一识别号、速度、高度等核心数据。据悉，该平台所具备的三维无人机飞行轨迹回放功能，可还原无人机完整飞行路径与数据，为后续处置提供了可视化证据与执法支撑。<p>' +
      '</p>' +
      '在日常巡逻执勤的民警佩戴便携式无人机识别肩灯后，能够及时侦测周边无人机信号并触发声光报警功能，配合移动端的低空卫士 APP 联动管理平台，通过页面地图精准定位无人机与飞手位置，由此构建起 "动态巡查 + 静态布防"的铁路全域立体监测体系，打破了固定监测点的范围局限，保障地面站的静态防控与民警佩戴肩灯的动态巡查实时互通、协同响应。<p>' +
      '</p>' +
      '我司与某地铁路公安将携手以技术创新为引擎，坚定树立"铁路安全比照民航安全"的标准，增加铁路沿线无人机安全管控数据接口，推动无人驾驶航空器一体化综合监管服务平台的迭代升级，以科技赋能与责任担当守护万千旅客的出行安全。',
    date: '2025.10.27',
    des: '忆伯科技携手某市铁路公安强化铁路沿线无人机监管。',
    cover: '/news/new55.png',
  },
  {
    id: 54,
    title: '忆伯科技肩灯助力南通苏超赛事安全，打造立体化低空安防新体系',
    content:
      '10月7日至19日，2025年江苏省城市足球联赛三场对决在“南鸟巢”南通体育会展中心体育场打响，最终由主场作战的南通队成为第二支进入“苏超”决赛的队伍。为确保赛事安全有序地进行，南通特警支队全面加强了低空安保部署，引入忆伯科技便携式无人机识别肩灯设备，有力提升了大型体育赛事的公共安全防控能力。<p>' +
      '</p>' +
      '赛事期间，南通特警支队构建“圈层防控+重点布防”的立体化、智能化安全防控体系，深度融合科技赋能，构建“地空协同、三维覆盖”的低空安全防控网络。通过部署地面警力配备肩灯设备，实时监控低空空域动态，实现身份可视、定位可溯、指令可达、应急可联。该肩灯可将无人机飞行信息完整呈现于移动端低空卫士APP，一旦发现无人机事件，肩灯立刻触发声光报警提示，精准定位无人机与飞手位置，显著增强一线执勤的响应协同能力。<p>' +
      '</p>' +
      '科技赋能智慧警力，驱动着警务模式从传统被动响应向主动防控、精准治理加速转型。忆伯科技将持续深耕低空感知与警力装备智能化领域，助力公安及城市管理部门实现数字化转型，为重大赛事、关键基础设施及公共安全场景提供坚实技术支撑，在守护城市平安的征程中贡献力量。<p>' +
      '</p>',
    date: '2025.10.24',
    des: '10月，忆伯科技肩灯助力南通特警支队全面加强苏超赛事安全。',
    cover: '/news/new54.png',
  },
  {
    id: 53,
    title: '新品亮相！忆伯科技参加2025第二届上海无人机展暨低空经济产业大会',
    content:
      '10月15日至17日，忆伯科技亮相以“聚链成势、赋能低空”为主题的2025第二届上海无人机展暨低空经济产业大会，与行业同仁共话低空经济发展新机遇。我司作为专注于低空管控解决方案商积极参与本次盛会，围绕产业发展的战略布局、技术路径及行业热点痛点问题，与业内专家、企业代表共同探讨低空经济高质量发展的实现路径。<p>' +
      '</p>' +
      '当前，低空经济正依托低空空域资源加速崛起，成为推动智慧交通、城市治理、日常巡检等领域创新的重要引擎。忆伯科技聚焦无人机监管难题，全面展示了如何保障低空安全的技术实力与落地能力。展会上，我司重点展出了便携式无人机识别肩灯、外挂式远程识别接收设备、无人机远程识别地面站、低空无线电侦测解析地面站等产品，吸引了众多观众驻足交流。<p>' +
      '</p>' +
      '其中，新品外挂式远程识别接收设备的核心优势在于其卓越的机动性，可贴于无人机上进行大范围移动式侦测，实时精准识别未登记无人机的飞行活动。设备在与低空有效监视管理平台协同运用时，平台将第一时间触发无人机事件预警，实现对低空空域的动态化、精准化监管。</p>' +
      '<p>' +
      '此外，为一线直管人员设计的便携式无人机识别肩灯具备轻巧灵活的特点，当设备在巡逻现场侦测到无人机RID信号后，将以震动和声光报警提示，直管人员可通过移动端“低空卫士”APP精准定位无人机与飞手位置，有效提高低空安防能力；无人机远程识别地面站能够',
    date: '2025.10.17',
    des: '10月15日至17日，忆伯科技携新品亮相第二届上海无人机展。',
    cover: '/news/new53.png',
  },
  {
    id: 52,
    title: '忆伯科技肩灯护航大邑古镇国庆假期低空安全',
    content:
      '在热烈喜庆的节日氛围中，大邑安仁古镇迎来了2025年“中秋+国庆”超级黄金周，共接待游客近60万人次。为避免未经报备的无人机等“低慢小”飞行器造成安全隐患，忆伯科技配合大邑公安针对大邑古镇人流密集、活动频繁等情况实施无人机禁飞管控，成功侦测1起无人机“黑飞”事件，切实维护了节日期间低空域安全稳定。<p>' +
      '</p>' +
      '长假期间，大邑公安重点围绕“保障公共安全、防范低空风险”的目标，通过建立指挥中心与一线管理人员的联动机制，严查“黑飞”行为。当我司无人机远程识别地面站接收到无人机RID信号，将立即触发低空有限监视管理平台预警功能并调度警力前往现场。执勤民警配备的便携式无人机识别肩灯可实时发出报警提示，结合移动端“低空卫士”APP显示的无人机及飞手精准位置信息，快速锁定目标。据悉，现场成功找到一名正在操作无人机的游客，经核查，该人员未完成报备登记，执勤民警随即对其开展教育并进行处置，有效防范了低空安全风险。<p>' +
      '</p>' +
      '目前，国内正在加快推进构建一体化低空空管体系，建立更加灵活高效的空域管理模式。忆伯科技将积极响应国家政策导向，助力完善低空动态监控与协同管控机制，实现低空监视网络的广域覆盖与全时保障，为构建统一高效、安全可控的监管体系提供有力支撑，促进低空经济健康有序发展。</p>' +
      '<p>',
    date: '2025.10.11',
    des: '10月针对大邑古镇人流密集等情况，忆伯科技配合大邑公安开展节日期间低空安全工作。',
    cover: '/news/new52.png',
  },
  {
    id: 51,
    title: '忆伯科技参加无线电发射设备管理“园区行”系列宣讲活动宝山专场',
    content:
      '9月18日，以“智慧测试筑基石 无线赋能启新程”为主题的2025年上海市无线电发射设备管理“园区行”系列宣讲活动宝山专场在南大智慧城成功举办。本次活动聚焦无线电技术在新兴产业融合与城市数字化转型中的关键作用，忆伯科技作为行业代表受邀参加并在现场分享我司实践案例。<p>' +
      '</p>' +
      '会上，忆伯科技立足“空天地一体化”的战略视角，深入探讨了低空智联技术在智慧城市构建中的广泛应用前景，展示了自主研发的无人机远程识别系列产品与低空有限监视管理平台。该平台通过通过精准侦测无人机的飞行状态，包括无人机的唯一识别号、经纬度位置、速度、高度、飞手位置等信息，有效应对“黑飞”扰航等低空安全挑战，已在勤务巡逻、城市管理、大型安保活动等全国80多地落地应用，显著提升城市低空域的精细化、智能化管控能力。<p>' +
      '</p>' +
      '忆伯科技作为建设宝山区科技创新生态的一分子，始终以技术实践赋能区域产业升级，推动宝山在无线电技术融合与新兴业态发展中的蓬勃动能。此次活动不仅深化了政企协同机制，更为推进无线电设备规范化管理与技术创新应用搭建了高效交流平台。忆伯科技将持续聚焦低空有效监视数字底座系统研发，助力上海乃至全国城市新基建迈向高质量发展新阶段。</p>' +
      '<p>',
    date: '2025.09.24',
    des: '9月18日，忆伯科技受邀参加上海市无线电发射设备宣讲活动。',
    cover: '/news/new51.png',
  },
  {
    id: 50,
    title: '全力护航！忆伯科技多维筑防焦作群星演唱会、国际太极拳大赛低空安全网',
    content:
      '9月，焦作市太极体育中心迎来了两场国际级盛事：9 月 13 日，“太极之夜” 群星演唱会以萧敬腾、周晓鸥、王赫野、姚晓棠、张紫豪、南拳妈妈等明星阵容，吸引了大量歌迷齐聚一堂；9 月 15 日晚，第十二届中国・焦作国际太极拳大赛暨 2025 云台山旅游节更是吸引了来自 32 个国家和地区的 2568 名运动员参与。<p>' +
      '</p>' +
      '该类大型安保活动不仅考验城市承载力，更对公共安全提出严峻挑战。在人员密集的活动现场，尤其在低空领域，无人机“黑飞”可能会引发空域冲突、隐私泄露及公共秩序风险等问题。为确保大型活动的安全，忆伯科技配合焦作公安，将科技赋能深度嵌入警务指挥链路，构建起空天地一体化低空安保体系。<p>' +
      '</p>' +
      '针对两场活动的不同场景需求，焦作公安围绕筑起“固移结合、立体分层”的智能防控网络。在静态防控层面上，焦作公安在活动前期实地测试，通过定点布局架设忆伯科技无人机远程识别地面站，全天候监测无人机的唯一识别码、经纬度位置、高度、速度、飞手位置等关键信息，实时同步至低空有效监视管理平台。当地面站接收到无人机RID信号时，平台将立刻触发“弹窗+报警”的提示功能，指挥部门结合警力分布情况，快速调度就近巡逻组前往处置，形成“技术赋能+人力支撑+智慧指挥”的三位一体低空安防闭环架构。</p>' +
      '' +
      '为实现 “快速反应、高效处置”，焦作公安考虑到活动现场人员流动大、重点区域分散的特点，为一线直管人员配备便携式无人机识别肩灯，组建移动巡查队伍，在管制关键区域不间断巡逻，实时侦测无人机飞行动态。一旦发现违规、未报备的无人机飞行，肩灯将第一时间报警提醒并同步平台，直管人员可根据低空卫士APP上所显示的无人机位置与飞手位置信息迅速前往处置，为全局防控决策提供数据支撑。' +
      '</p>' +
      '未来，针对大型活动、城市管理、景区防护等多元化场景的安全管理需求，忆伯科技将践行公共安全理念，持续推动低空综合管制技术与城市运行管理机制的双向融合，打通监测数据与指挥调度的协同链路，提升直管部门对潜在风险的预判能力和突发事件的应急处置能力，筑牢国内低空空域交通安全防线。',
    date: '2025.09.23',
    des: '9月，忆伯科技配合焦作公安圆满完成焦作市太极体育中心两场大型活动。',
    cover: '/news/new50.png',
  },
  {
    id: 49,
    title: '“足”够燃，防控硬：忆伯科技全力保障“苏超”赛事低空安全',
    content:
      '9月7日，江苏省城市足球联赛第11轮比赛火爆开场，现场3万多名球迷热情高涨、气氛热烈。为确保赛事的有序开展，忆伯科技全程配合某地市公安落实低空安保措施，始终将苏超赛事安全置于首要位置，坚持“预防为主、科技赋能、协同作战”为原则，构建起“空地一体、动静结合、全域覆盖”的立体化安全防控体系。<p>' +
      '</p>' +
      '在本次安保任务中，忆伯科技协助某地市公安严格遵循“立体防控、筑牢安全屏障”的基本要求，全面加强低空安全防控力度，切实保障赛事期间空域安全稳定。为提升低空管理能力，某地市公安在体育场重点区域部署了忆伯科技自主研发的无人机远程识别地面站，实现对低空飞行目标的全天候、固定式侦测覆盖，并通过低空有效监视管理平台实时掌握场馆周边的低空飞行态势，确保“看得见、识得清、控得住”，为指挥调度提供数据支撑。<p>' +
      '</p>' +
      '通过“固定侦测+移动布防”的双轨运行模式，一线直管人员佩戴便携式无人机识别肩灯设备后，可在发现无人机飞行事件时，实时报警定位无人机及飞手位置信息，迅速联动相关处置力量。同时，肩灯与管理平台具备数据互通功能，构建起“数据上图、位置锁定、行动联动”的高效响应机制，真正实现在大型安保任务中低空防控的智能化、精细化管理。</p>' +
      '<p>' +
      '伴随着低空空域运行的复杂性显著增加，在安全风险日益突出的挑战之下，忆伯科技将持续优化动态管理机制和技术支撑体系，为国内低空安全发展提供更高效、更智能、更协同的低空防控方案，为构建更高水平的城市安全防线贡献力量。',
    date: '2025.09.08',
    des: '9月7日，忆伯科技圆满完成苏超赛事低空安全工作。',
    cover: '/news/new49.jpg',
  },
  {
    id: 48,
    title: '无线上海 智联世界——忆伯科技亮相2025年上海无线电管理宣传月活动',
    content:
      '9月5日，“无线上海 智联世界”2025年上海无线电管理宣传月主题活动在上海国际时尚中心隆重举行，全面展示了无线电技术在推动城市数字化转型、赋能千行百业中的关键作用。忆伯科技作为低空无线电监视数字底座领域的方案商，携自主研发的便携式无人机远程识别地面站与便携式无人机识别肩灯等产品亮相，与政府部门、行业企业、高校院所及媒体代表共聚一堂，共话无线电技术的创新应用与管理成效。<p>' +
      '</p>' +
      '无线电频谱作为支撑数字时代城市发展的关键资源，正以前所未有的速度连接万物、赋能产业。活动现场，我司与各界嘉宾深入交流，分享在无线电监测与数据应用方面的实践经验，并探讨未来在数字化城市建设中的合作契机。我司通过深入探索无线电技术的深度应用，能够实现对低空环境的精准感知与高效管理，解决无人机黑飞、滥用等问题，凭借地面站、肩灯与低空有限监视管理平台的联动机制，实时展现无人机的电子牌照、位置、高度、速度、飞手位置等信息，为智慧城市、公共安全、应急管理等领域提供坚实的技术支撑。<p>' +
      '</p>' +
      '未来，忆伯科技将进一步增强对无线电管理工作的认知与支持，持续激发低空无线电管控技术在推动产业创新的应用潜力，推动城市治理体系和治理能力现代化，助力构建更加智能、高效、安全的低空经济发展新格局，为上海量子城市建设保驾护航。</p>',
    date: '2025.09.08',
    des: '9月5日，忆伯科技参加2025年上海无线电管理宣传月主题活动。',
    cover: '/news/new48.png',
  },
  {
    id: 47,
    title: '多重防线，联动高效！忆伯科技圆满完成上合作组织峰会低空安保工作',
    content:
      '8月31日至9月1日，2025年上海合作组织峰会（以下简称“上合组织峰会”）在天津举行。这是中国时隔7年再次举办上合组织峰会，也是上合组织成立以来规模最大的一届峰会，不仅展现了中国城市的魅力，更对重大安保活动安全管理向更加精细化、专业化方向迈进提出要求。<p>' +
      '</p>' +
      '为保障上合组织峰会举办期间的安全，忆伯科技配合天津特警，依据峰会场馆及周边区域的地形地貌、活动安排和安保重点，全面构建起严密的低空安全防护网，圆满完成上合组织峰会的低空安保工作。<p>' +
      '</p>' +
      '预先部署防线，多层次立体化防护网络</p>' +
      '</p>' +
      '为保障峰会期间重点区域的低空安全，天津特警针对关键场所构建“核心巡逻管控区 - 固定值守监测区 - 周边应急响应区”三道核心监测防线，形成立体化、分层级的低空监测网络，确保及时发现并处置任何潜在的无人机安全隐患</p>' +
      '<p>' +
      '核心巡逻管控区作为第一道防线，重点覆盖峰会会场内侧的关键范围。通过直管人员佩戴多个便携式无人机识别肩灯开展动态巡逻，以流动性监测模式扩大防控半径，及时排查潜在安全隐患，筑牢低空安全防控的“核心屏障”。</p>' +
      '<p>' +
      '固定值守监测区聚焦重点场所的关键缓冲地带进行定点值守，结合肩灯的实时监测无人机信号功能，强化对重点区域周边的精准管控。同时，天津特警考虑到人员流动大、环境复杂的特点，由直管人员近距离守护紧邻峰会主会场的建筑、交通枢纽等人员密集核心区域，通过增加肩灯的配备数量以提高监测密度，搭建起空地联动的立体化防控体系，确保重点区域低空态势的实时感知与动态掌控。</p>' +
      '</p>' +
      '多维联动机制，精准识别无人机与飞手</p>' +
      '<p>' +
      '在上合组织峰会期间，天津特警将肩灯深度灵活融入低空安保工作中，显著提升了应急响应能力，成功发现6起无人机事件，为峰会顺利举办营造安全稳定的低空环境，赢得相关部门、参会各方及各国代表团的高度认可，切实彰显了技术装备与低空管控方案在重大安保活动中的实战效能和可靠性。</p>' +
      '<p>' +
      '面对复杂多变的环境和高强度的管控需求，直管人员通过肩灯与低空卫士 APP、低空有效监视管理平台的无缝对接，与安保指挥中心构建高效的联动机制。肩灯在接收到无人机远程识别信号后，将第一时间触发报警提示，指挥中心立即通过调度附近安保力量，派遣人员根据APP 实时显示的无人机及飞手位置及时前往处置，确保对每一起无人机事件都能做到情况掌握准确、应对决策及时。</p>' +
      '<p>' +
      '据悉，涉事飞手多为摄影爱好者，因对峰会现场好奇而进行飞行拍摄，且不了解峰会空域规定。直管人员当场制止飞行、要求降落无人机，针对无违法意图的飞手开展法治教育并劝离，告知其在未经许可的情况下，在峰会核心区域附近操控无人机飞行存在严重的安全风险。</p>' +
      '</p>' +
      '拓展防控边界，低空数字底座持续升级</p>' +
      '<p>' +
      '在当前社会安全形势日益复杂的背景下，安保任务不仅呈现出日益繁重的趋势，而且对技术手段的要求也在不断提高。从重大活动的安保实践来看，低空管控作为保障安全的重要一环，其重要性愈发凸显。</p>' +
      '<p>' +
      '技术的价值在于服务社会。忆伯科技将以技术赋能实战的理念继续前行，持续完善低空管控数字底座，提高低空监测、预警和处置能力，力求在更多领域实现技术的深度应用，将低空管控技术拓展至城市日常巡逻、边境管控等多元化场景，推动技术从“点”向“面”的延伸，助力提升国家安全、公共安全和社会安全的防控能力。</p>',
    date: '2025.09.04',
    des: '8月31日至9月1日，忆伯科技配合天津特警圆满完成上合组织峰会的低空安保工作。',
    cover: '/news/new47.png',
  },
  {
    id: 46,
    title: '为祖国点赞！忆伯科技党支部组织观看纪念抗战胜利80周年阅兵式',
    content:
      '9月3日，为纪念中国人民抗日战争暨世界反法西斯战争胜利80周年，忆伯科技党支部组织全体党员及员工代表集中观看“9.3阅兵”仪式。在观礼中，怀揣着崇敬的心情，认真倾听中共中央总书记、国家主席、中央军委主席习近平发表重要讲话，深刻铭记抗战历史，汲取奋进力量。<p>' +
      '</p>' +
      '上午9时，阅兵式正式开始。在党旗、国旗、军旗引领下，受阅方队迈着铿锵步伐阔步走来，鼓舞人心。鲜红的旗帜迎风招展，装备方队缓缓驶过。从歼-20S隐身战机到“惊雷-1”空基远程导弹，从99B新型主战坦克到100支援战车，从察打一体无人机到新型无人潜航器，一件件凝聚着国家科技实力的空天地海装备依次亮相，不仅展示出我国国防现代化建设的跨越式发展，更彰显着中国守护和平、捍卫主权的坚定底气。<p>' +
      '</p>' +
      '观礼结束后，震撼与自豪之情在每个人的心中久久回荡。在今后的工作中，忆伯科技将带领全体员工坚定投身于实现中华民族伟大复兴的新征程，坚守初心、勇担使命，为公司发展注入强劲动力，为祖国的繁荣昌盛贡献坚实力量。</p>',
    date: '2025.09.03',
    des: '9月3日，忆伯科技党支部组织全体党员及员工代表集中观看“9.3阅兵”仪式。',
    cover: '/news/new46.png',
  },
  {
    id: 45,
    title: '忆伯科技参加2025长三角低空经济大会，荣获“突出贡献单位”奖',
    content:
      '8月28日，忆伯科技参加2025长三角数字经济助力低空经济高质量发展大会暨第4届未来空间&高端制造高质量发展大会。本次大会以“杨‘数’浦 航未来”为主题，汇聚低空经济、航空航天、数字经济、高端制造等领域政企学研代表200多人，旨在搭建长三角未来空间产业链协同平台，共话低空、共创未来，助力区域低空经济、数字经济与高端制造产业高质量发展。<p>' +
      '</p>' +
      '大会期间，与会嘉宾围绕低空经济的发展潜力、数字经济的创新应用等热点议题展开了深入讨论。从政策明确安全健康发展方向，到智能化管控体系、数字技术、智能传感等技术支撑，再到空域管理优化，安全理念贯穿了低空经济产业链的各环节。<p>' +
      '</p>' +
      '一直以来，忆伯科技致力于为低空经济的安全发展提供坚实可靠的数字底座与基础设施支撑。凭借在低空管控领域取得的成果，荣获“2025未来空间产业链发展突出贡献单位”奖项，充分体现了行业对我司技术实力和发展方向的高度认可。</p>' +
      '<p>' +
      '忆伯科技将持续以全域管制技术创新为核心驱动力，紧密对接长三角一体化发展战略，着力打造低空应用标杆场景，不断升级无人机远程识别部署方案与低空有效监视管理平台，助力解决低空经济发展中的技术瓶颈、管理响应不及时等难题，积极探索低空经济发展新场景、新模式，为推动我国低空经济高质量发展、构建现代化产业体系贡献更多力量。' +
      '</p>',
    date: '2025.08.28',
    des: '8月28日，忆伯科技2025长三角数字经济助力低空经济高质量发展大会。',
    cover: '/news/new45.png',
  },
  {
    id: 43,
    title: '以青春之名，聚奋进之力——忆伯科技团支部正式成立',
    content:
      '为深入学习贯彻习近平总书记关于青年工作的重要思想和关于社会工作的重要论述，落实党建带团建制度机制，经共青团上海市宝山区杨行镇委员会批准，共青团上海忆伯科技股份有限公司支部委员会正式成立。<p>' +
      '</p>' +
      '团支部的成立，是新时代加强企业团建工作、激发青年员工活力的重要举措。我司团支部将围绕企业中心任务，以健全团的组织体系为坚实依托，凝聚引领团员青年筑牢理想信念之基、勇担时代使命之责，充分激发青年群体在岗位实践中的澎湃活力与创新潜能。<p>' +
      '</p>' +
      '未来，公司团支部将在上级团组织和公司党支部的领导下，持续加强组织建设，提升服务能力，充分发挥团结青年、组织青年、服务青年的职能作用，为推动企业高质量发展注入青春活力、贡献青春力量。</p>',
    date: '2025.08.15',
    des: '为落实党建带团建制度机制，经批准共青团上海忆伯科技股份有限公司支部委员会正式成立。',
    cover: '/news/new43.png',
  },
  {
    id: 44,
    title: '喜报！忆伯科技获批2025年度宝山区企业技术中心认定',
    content:
      '8月1日，上海市宝山区人民政府正式公示《2025年度拟认定宝山区企业技术中心名单》。经宝山区经委组织及专家组评审，忆伯科技以技术革新、研发实力、方案应用等方面的卓越表现，荣列该认定名单。<p>' +
      '</p>' +
      '此次入选，不仅是对忆伯科技过往在低空管制、智慧警务、智慧城市以及航海航天等领域所取得成果的高度肯定，更标志着我司在技术成果转化、行业赋能建设方面迈入全新阶段。我司将以此为动力，持续完善方案与应用深度融合的科技创新机制，进一步激发自主研发能力，全面提升核心竞争力，为各行业迈向更高质量发展阶段而赋能。<p>' +
      '</p>',
    date: '2025.08.09',
    des: '8月1日，忆伯科技荣列2025年度宝山区企业技术中心认定名单。',
    cover: '/news/new44.png',
  },
  {
    id: 41,
    title: '忆伯科技正式成为深圳市无人机行业协会会员单位，共助低空发展新路径',
    content:
      '8月1日，忆伯科技凭借在低空管制、智慧警务、智慧城市以及航海航天等领域的持续耕耘与创新实力，正式成为深圳市无人机行业协会会员单位（以下简称“深无协”）。这不仅是对我司专业能力的高度认可，更是一份激励我们砥砺前行的责任。<p>' +
      '</p>' +
      '长期以来，忆伯科技凭借对行业趋势的敏锐洞察，依托多年在无线电有效侦测技术领域的研发经验，在全国80多个省市政府决策中枢、直管部门、企事业单位打造以RID、ADS-B、AIS等核心技术的收发设备及解决方案，并广泛应用于低空管制、智慧警务、智慧城市以及航海航天等多个领域。<p>' +
      '</p>' +
      '展望未来，忆伯科技将与深无协深度携手，充分自身扎实的技术积淀，积极参与低空经济生态构建，共同探索低空经济的广阔蓝海。<p>',
    date: '2025.08.07',
    des: '8月1日，忆伯科技正式成为深圳市无人机行业协会会员单位。',
    cover: '/news/new41.png',
  },
  {
    id: 40,
    title: '忆伯科技与南京江北分局上榜2025年安防产品和技术典型应用案例名单',
    content:
      '近日，为深入贯彻落实党的二十大精神，加快推动安防行业产品与技术的快速发展和转型升级，满足各级政府和相关重点行业的应用需求，中国安全防范产品行业协会正式揭晓“2025年安防产品和技术典型应用案例征集活动”推荐名单。经严格评审，我司与南京市公安局江北新区分局低空勤务保障中心共同推选的“某市公安分局分布式边缘计算低空有效监视系统项目”入围无人系统领域典型应用案例名单，充分认可了我司在低空管理领域的技术创新能力。<p>' +
      '</p>' +
      '为应对无人机黑飞等违规发现与处置问题，该项目针对低空安全管控需求，依托无人机远程识别等综合技术手段，自主研发了便携式无人机识别肩灯，适配日常巡逻与大型安保等任务，具备无人机侦测功能。当发现无人机时，肩灯会通过震动蜂鸣报警，将无人机飞行数据同步低空卫士APP与低空有效监视管理平台，有效推动了监管模式从“事后追溯”向“实时预警”升级，提升了直管部门对低空安全风险的感知与处置能力，实现“机-人-地”全要素关联管控。<p>' +
      '</p>' +
      '安全是通用航空和低空经济发展的生命线。未来，忆伯科技将坚持将安全理念贯穿于全域立体解决方案，为国内打造协同高效、全域覆盖的低空智联网，为公共安全管理提供了有力支撑，为低空经济运行提供坚实保障。<p>',
    date: '2025.08.06',
    des: '我司与南京江北分局入选2025年安防产品和技术典型应用案例名单。',
    cover: '/news/new40.png',
  },
  {
    id: 39,
    title: '忆伯科技参加2025国际低空经济博览会，荣获“空域应用开拓奖”',
    content:
      '7月23日至26日，首届国际低空经济博览会在上海国家会展中心盛大开幕，吸引全球行业上下游近300家头部企业参展，标志着上海乃至中国在抢抓低空经济新赛道、培育新质生产力、构建现代化产业体系方面迈出了坚实一步。<p>' +
      '</p>' +
      '本届博览会以“启航低空经济，赋能千行百业”为主题，忆伯科技携自主研发的无人机远程识别侦测设备亮相展会，通过产品展示、技术交流、应用场景等多维度展现我司在低空管控领域的创新成果。<p>' +
      '</p>' +
      '忆伯科技便携式无人机识别肩灯与无人机远程识别地面站所拥有的精准识别无人机RID信号的能力，吸引了众多海内外观众的驻足围观与热烈交流。我司现场演示了低空有效监视管理平台在与肩灯、地面站联动后，快速触发弹窗报警机制，清晰展现无人机事件与实时轨迹追踪过程，分析呈现无人机的机型、经纬度位置、速度、高度、飞手位置等关键数据，实现对低空立体化监视管理，有效解决盲区多、数量多、响应慢等问题。<p>' +
      '</p>' +
      '无人机远程识别部署管理方案强调低空管控在推动低空经济规范化发展的重要作用，适用于监测无人机在机场、体育场、火车站、临时安保活动等重要区域的飞行情况，提升直管部门在进行管制任务中的信息时效性和协同性，及时预警并制止违规飞行操作，构建起全程可视、全域可控、全程可溯的闭环监管架构，保障低空交通枢纽的安全运行。<p>' +
      '</p>' +
      '同期，忆伯科技凭借在空域管控方面的技术实践与卓越性能，荣获“空域应用开拓奖”。这不仅是对我司在低空领域不断开拓、推动应用落地的高度认可，更是我司对持续加强全域立体管理体系构建的动力。<p>' +
      '</p>' +
      '忆伯科技始终关注夯实低空安全管控基础，我们深知，安全是低空领域繁荣的基石，是创新腾飞的翅膀。我们将持续深耕全域立体管理技术，以数字化、智能化、网络化为路径，构建覆盖“感知-预警-管控-服务”全链条的智慧低空安全防护网，赋能城市管理、应急救援、文旅体验等多元场景蓬勃发展，助力推进通用航空和低空经济发展。<p>',
    date: '2025.07.26',
    des: '7月23日至26日，忆伯科技携无人机远程识别侦测设备亮相国际低空经济博览会。',
    cover: '/news/new39.png',
  },
  {
    id: 38,
    title: '多单位代表参访忆伯科技，共话低空建设与应用',
    content:
      '7月15日，上海市无线电协会、上海电信、三吉电子、金桥股份及幻飞智控等单位代表莅临我司，围绕低空经济基础设施建设方案落地及相关设备应用展开深入交流探讨，为推动区域低空经济高质量发展凝聚共识。<p>' +
      '</p>' +
      '会上，各单位代表结合自身领域经验，就低空经济发展的核心需求与实践路径展开热烈讨论，就低空监测设备的技术创新与场景适配进行深入对接。我司向各位代表分享了无人机远程识别部署管理方案与低空有效管理平台的核心内容，依托分布式网格化布局，实现对无人机的实时身份核验、轨迹追踪与动态预警，有效规避黑飞、扰飞等安全风险，以此构建 “空天地一体化”通信网络，为直管部门提供科学决策与支持。<p>' +
      '</p>' +
      '我司以此次交流为契机，后续将进一步整合低空管控技术、资源与场景优势，与各单位共同推进低空经济基础设施建设方案的细化与落地，助力国内低空经济产业生态的建立与完善。<p>',
    date: '2025.07.16',
    des: '7月15日，多家单位代表莅临我司参观交流，围绕低空经济发展进行了深入探讨。',
    cover: '/news/new38.png',
  },
  {
    id: 37,
    title: '寻初心，铸党魂——上海忆伯科技党支部开展中共一大会址参观学习',
    content:
      '7月1日，为热烈庆祝中国共产党成立104周年，上海忆伯科技股份有限公司党支部组织全体党员赴中共一大会址，开展红色教育活动。<p>' +
      '</p>' +
      '中共一大会址纪念馆，这座承载着厚重历史的石库门建筑，见证了中国共产党的诞生，开启了中华民族走向伟大复兴的征程。驻足于珍贵的革命文物和复原的会议场景之前，党员们深刻感受到革命先驱们在风雨如晦的岁月里的坚定信仰，点燃了照亮民族前途的信仰火炬。重温的入党誓言穿越百年风雨，让大家深刻认识到党的初心使命历久弥坚，要不忘来时路，走好脚下路。<p>' +
      '</p>' +
      '此次活动是我司党支部深化制度建设，淬炼党员党性的重要实践。唯有持续加强党的建设，传承红色基因，才能不断凝聚起攻坚克难的磅礴力量。我司将立足岗位、勇于担当、实干争先，为实现企业战略目标和高质量发展贡献坚实力量。<p>',
    date: '2025.07.02',
    des: '7月1日，上海忆伯科技股份有限公司党支部组织全体党员赴中共一大会址开展红色教育活动。',
    cover: '/news/new37.png',
  },
  {
    id: 36,
    title: '全程“静音模式”：忆伯科技肩灯全力保障成都大邑中考低空护考工作',
    content:
      '6月13日至14日，成都市中考如约而至，共有3535名考生参加考试设有大邑中学、安仁中学2个考点、118个考场。为保障考场环境的安静与有序，忆伯科技积极响应，紧密配合成都大邑公安开展2025中考低空安全护考工作。<p>' +
      '</p>' +
      '中考期间，成都大邑公安全面统筹护考工作，对考场周围提前设置警戒区域，通过人员配备忆伯科技便携式无人机识别肩灯全天候监视低空情况，严格执行低空管制任务，全程开启“静音模式”。该肩灯在接收到无人机远程识别信号时，将实时声光报警提示，与移动端低空卫士 APP和低空有效监视平台同步数据，精准识别管制区域内无人机的经纬度位置、飞行轨迹以及飞手位置，有效维护考场周边的低空秩序。<p>' +
      '</p>' +
      '忆伯科技作为低空管控领域的探索者与实践者，将持续为广大客户提供低空安全治理方案，及时消除低空安全隐患，加强空中交通管理协同统筹能力，实现全程精准监视、预警和联动机制，推进国内低空空域的基础设施、飞行服务等保障工作的落实。<p>',
    date: '2025.06.18',
    des: '6月13日至14日，忆伯科技紧密配合成都大邑公安开展2025中考低空安全护考工作。',
    cover: '/news/new36.png',
  },
  {
    id: 35,
    title: '忆伯科技党支部正式成立，凝心聚力强党建',
    content:
      '为深入贯彻落实党的二十大精神，加强基层党组织建设，充分发挥党建引领企业发展的核心作用，经中共上海市宝山区杨行镇委员会批准，中共上海忆伯科技股份有限公司支部委员会正式成立，标志着我司在党建工作上迈出了坚实一步。<p>' +
      '</p>' +
      '党支部的成立，为公司注入了强劲的“红色动力”。党支部的建立是以“支部牵头、企业联动、党员协同”为工作方向，是把党的政治优势、组织优势转化为企业的发展优势，促进企业可持续发展，引导公司全员积极践行党的宗旨，以更高的责任感和使命感投入工作，在技术创新、服务优化等领域发挥先锋模范作用。<p>' +
      '</p>' +
      '忆伯科技党支部将以党建为引领，以习近平新时代中国特色社会主义思想为指导，积极开展形式多样的党建活动，培育特色党建品牌，推动党建与业务深度融合，为公司高质量发展提供坚强的政治保障和组织保障，助力我司在新时代的浪潮中行稳致远。<p>',
    date: '2025.06.16',
    des: '为充分发挥党建引领企业发展的核心作用，经批准中共上海忆伯科技股份有限公司支部委员会正式成立。',
    cover: '/news/new35.png',
  },

  {
    id: 34,
    title: '护航高考：忆伯科技无人机识别肩灯全程守护多地考场低空安全',
    content:
      '6月7日至10日，2025年高考火热开考。为确保考点周边保持良好的治安环境，忆伯科技配合临朐公安、歙县公安全程开展高考护航行动，圆满完成2025年高考低空安保任务。<p>' +
      '</p>' +
      '为筑牢考试期间各考点的低空安全防线，临朐公安、歙县公安进行周密部署，进一步强化了考点周边的巡逻执勤工作，通过佩戴我司自主研发的便携式无人机识别肩灯，全面定点实施无人机管控。该设备集成无人机远程识别接收和普通肩灯功能，可与低空卫士APP同步数据，精准实时展现定位考点周边空域无人机的飞行轨迹，便于有效防范无人机违规操作、干扰考试等安全隐患，为广大考生营造了安静、安全的考试环境。<p>' +
      '</p>' +
      '未来，我司将持续深耕低空管控领域，通过构建全方位有效覆盖、全天候发挥作用、全要素高效运行的低空安全防护网，不断优化无人机远程识别设备的性能，深度挖掘我司在低空安全管理中的应用潜力，为警务工作注入有力的科技动能。<p>',
    date: '2025.06.11',
    des: '6月7日至10日，忆伯科技配合临朐公安、歙县公安全程开展高考护航行动。',
    cover: '/news/new34.png',
  },
  {
    id: 33,
    title: '百舸争流！忆伯科技圆满护航永州道县龙舟赛低空安全',
    content:
      '5月24日至31日，为迎接端午节的到来，中国龙舟公开赛、国家非遗龙船赛暨国家非遗道州龙船超级联赛在湖南省道县潇水河畔开赛，吸引了全国各地的百余万游客前来观看5000余运动员200支龙舟队的奋楫竞渡。忆伯科技配合永州公安、道县公安提供无人机远程识别部署管理方案，圆满完成赛事低空安保工作。为保证龙舟赛事的顺利进行，永州公安、道县公安根据主阵地和沿岸的实地情况，配备了多套忆伯科技无人机远程识别设备，多警力联动开展动态化巡控，以“定点＋步巡”相结合的方式不间断密集巡逻。<p>' +
      '</p>' +
      '为全面维护赛事区域的低空安全，现场部署了忆伯科技无人机远程识别地面站，通过与低空有效监视管理平台、便携式无人机识别肩灯形成低空防控网络，在城市范围内实现全天候低空立体化监视，实时识别无人机的唯一识别码、机型型号、经纬度位置、飞行轨迹、飞手位置等数据至平台呈现，支持轨迹回放、黑白名单设置、无人机事件统计等功能，提升对赛事低空态势的感知能力与响应速度。<p>' +
      '</p>' +
      '按照分布式监测节点，直管人员佩戴便携式无人机识别肩灯可实时侦测1公里范围内的低空活动。当肩灯监视到无人机广播的RID信号时，将立刻触发声光报警并伴随震动提示，通过查看移动端低空卫士APP和低空有效监视管理平台，锁定无人机的经纬度位置和飞手位置等信息，提高了对低空目标的追踪效率。该方案不仅加强了现场低空布控数据互联与信息同步，还确保了直管人员能够在复杂环境中掌握低空交通安全情况。<p>' +
      '</p>' +
      '当下，低空经济正“飞跃”千行百业，积极探索低空灯光秀、无人机城市巡检、空中出租车等新业态。忆伯科技始终秉持‘安全为先’的发展理念，致力于筑牢各类应用场景的低空安全防线，为各领域提供定制化低空管制解决方案，将持续推动低空经济在安全可控的前提下实现高质量发展，为深度构建智慧、安全、高效的低空管控体系贡献力量。<p>',
    date: '2025.06.05',
    des: '5月24日至31日，忆伯科技圆满完成永州道县龙舟赛低空安保工作。',
    cover: '/news/new33.png',
  },
  {
    id: 32,
    title: '深圳第九届世界无人机大会圆满落幕，忆伯科技低空管控方案备受瞩目',
    content:
      '5月23日至25日，忆伯科技赴深圳会展中心参加2025第九届世界无人机大会暨2025国际低空经济与无人系统博览会、第十届深圳国际无人机展览会。本届低空全产业链大会紧扣“步入低空经济新时代”的主题，吸引全球100多个国家和地区的13万专业观众参会，共同解码低空经济新质生产力。<p>' +
      '</p>' +
      '针对当前低空监管实践中存在的定位追踪不及时、飞手身份溯源不精确等突出问题，忆伯科技携无人机远程识别部署管理方案，与现场国内外客户围绕低空安全管理难点，就无人机监管的技术创新路径、政策落地实践、场景化应用方案等维度进行了多层次探讨，展现了忆伯科技在低空管控领域的多款最新产品。<p>' +
      '</p>' +
      '伴随着低空经济产业以蓬勃之势实现规模跃升，飞行安全风险同样呈几何级增长，无人机“黑飞”、违规操作事件屡禁不止，不仅对国家空域管理秩序构成严峻挑战，更成为低空产业高质量发展的核心瓶颈。国家发改委于近日从战略高度明确指出 “安全是低空经济发展的首要前提”，要求要严厉打击驾驶员无证、低空航空器未取得适航证、飞行活动未报批等“黑飞”行为，引导推动产业合理布局、场景有序拓展。<p>' +
      '</p>' +
      '我们认为政策落地与监管体系构建离不开技术赋能。忆伯科技无人机远程识别部署管理方案综合了远程识别、5G-A等前沿低空管制技术，在网格化部署无人机远程识别地面站，通过构建立体低空交通网络，同步联动低空有效监视管理平台，平台将实时同步无人机的唯一识别码、经纬度位置、高度、速度、飞手位置等信息。在城市环境下，无人机远程识别地面站全天候监视解析1-2公里内的无人机事件，空旷环境下可达到5公里。通过平台的视频回放功能实现对无人机的动态轨迹监测，为构建 “全域覆盖、实时预警、全程可溯”的低空安全治理体系提供全国产化技术保障，推动低空安全监管能力实现跨越式升级。<p>' +
      '</p>' +
      '在展会现场，可同时与低空有效监视管理平台、移动端低空卫士APP连接的便携式无人机识别肩灯获得了广大客户与观众的高度认可。该肩灯与无人机远程识别地面站相比，具备轻便佩戴、灵活部署的特点。在稳定接收无人机远程识别信号的功能基础上，支持一键切换低空管控与普通照明肩灯模式，有效监视1公里范围内的低空状况。在肩灯发现无人机时，将第一时间触发震动和蜂鸣声报警提示，直管人员只需通过平台或低空卫士APP锁定无人机及飞手位置等信息，现已投入部署国内各省级多起大型体育赛事、日常巡逻安保等活动。<p>' +
      '</p>' +
      '此外，支持DJI O4解析的新升级产品苍蓝忆识4PRO集无人机远程识别、飞控链路协议解析、ADS-B、AIS技术于一体，旨在搭建“空天地海”一体化管理网络，以数据驱动、智能协同的创新模式，实现民航、通航、海事区域的全方位管制。<p>' +
      '</p>' +
      '本次无人机盛会圆满落下帷幕，忆伯科技作为低空管控领域的深耕者充分展示了前沿技术与创新成果，将坚持管得住才能放得开，锚定城市低空精细化管理为目标持续发力，不断打磨健全低空管控监管技术水平，兼顾各类管制任务与应用场景的实际需求，维护航空安全、公共安全、国家安全，促进低空经济安全健康发展。<p>' +
      '</p>',
    date: '2025.05.28',
    des: '5月23日至25日，忆伯科技赴深圳会展中心参加2025第九届世界无人机大会。',
    cover: '/news/new32.png',
  },
  {
    id: 31,
    title: '忆伯科技低空管控方案亮相第十二届警博会，助力提升新质战斗力',
    content:
      '5月14日至17日，由公安部主办的第十二届中国国际警用装备博览会在北京首钢国际会展中心开幕。本届警博会以“新技术、新装备、新质战斗力”为主题，邀请国内外警用装备企业和科研机构参展。<p>' +
      '</p>' +
      '忆伯科技凭借在低空管控领域的技术突破，以低空有效监视数字化底座为方案重心，加速向低空安防场景融合渗透，破解无人机黑飞事前锁定难、事后追溯难问题，获得了行业的一致好评与认可。在展会期间，我司携便携式无人机识别肩灯、无人机远程识别地面站、低空无线电侦测解析地面站、小型无人机远程识别地面站、便携式无人机识别眼镜等多款最新升级产品亮相现场，与各地公安领导深入探讨警用装备的最新应用与发展成就，吸引了众多客户和观众的驻足参观。<p>' +
      '</p>' +
      '忆伯科技紧抓低空警务改革窗口，呼应国内规划空地一体治安防控战略，将无人机远程识别部署管理方案投入低空警务实战中。通过部署远程识别地面站联动低空有效监视管理平台，实时侦测具备远程识别功能的无人机在管制区域内飞行，获取无人机的唯一识别号、经纬度位置、高度、速度、机型型号、飞手位置等信息，在城市范围内可探测1-2公里，空旷环境可达5公里，有效提升直管部门掌握低空交通情况的管理能力。<p>' +
      '</p>' +
      '便携式无人机识别肩灯作为本次展会备受关注的核心产品之一，现已新增震动提示功能，不仅具备无人机远程识别接收功能，还支持一键切换低空管控与普通肩灯模式，有效侦测范围在1公里左右。当发现黑飞无人机时，肩灯将立即“震动+蜂鸣”报警，低空卫士APP同步该无人机的飞行数据，定位飞手位置与飞行轨迹，配合直管人员迅速锁定并控制，保障日常巡逻与大型安保活动等任务的低空空域安全。目前，该肩灯已在全国范围内参与多起低空安防活动，推动低空监视模式从“事后追踪”向“实时预警”升级。<p>' +
      '</p>' +
      '此外，升级的低空无线电侦测解析地面站苍蓝忆识4RPO相较上一代苍蓝忆识PRO，在原有功能稳定的基础上，新增支持DJI O4解析功能，可探测1-4公里区域（实际探测区域取决于安装位置，如高度和大型建筑物的阻挡情况）。苍蓝忆识系列作为集无人机远程识别、飞控链路协议解析、ADS-B、AIS技术于一体的地面接收站，有力增强民航、通航、海事等重要管制应用场景的安全性。<p>' +
      '</p>' +
      '本次展会中，忆伯科技首次公开发布了最新产品小型无人机远程识别地面站与概念性产品便携式无人机识别眼镜，旨在通过创新各类低空监测设备，以轻量化、便捷性为导向，综合多元化低空监视手段，实现协同作战、低空监视与信息同步共享，构建空地一体的协同监测体系。<p>' +
      '</p>' +
      '在现代化科技加速跃迁的变革浪潮中，警用装备的智能化、立体化应用效能逐步显现。忆伯科技始终以“科技创新引领战略”为目标，以健全低空管理体系为核心，聚焦低空立体交通管理建设工作，将持续完善“简便部署-识别预警-有效监视-快速响应”的闭环监管架构，积极聆听市场与客户需求，以技术创新驱动低空领域管理效能提升，为构建安全、高效、智能的低空管控方案与警用装备贡献力量。<p>' +
      '</p>',
    date: '2025.05.20',
    des: '忆伯科技低空管控方案亮相第十二届警博会，助力提升新质战斗力',
    cover: '/news/new31.png',
  },
  {
    id: 30,
    title: '忆伯科技圆满护航某省市自行车赛事低空安全',
    content:
      '4月下旬，某省市自行车赛拉开帷幕，吸引来自国内外千名自行车爱好者报名参赛。为克服沿途路程较长、活动时间长、管控难度较大等多困难，忆伯科技配合以全局统筹部署、多维协同目标推进，全程做好低空安全保障工作。<p>' +
      '</p>' +
      '在赛事期间，忆伯科技充分发挥低空有效监视技术优势，根据实地情况构建低空安全管制方案，有效提升对低空空域飞行器的管控能力。针对重点管制区域，通过“定点布控+流动巡逻”的立体布防模式，将自主研发的便携式无人机远程识别肩灯作为现场低空管控的主力设备，动态侦测赛事低空空域情况。<p>' +
      '</p>' +
      '当可随身携带的肩灯接收到无人机的RID信号后，将实时进行震动和蜂鸣提示，直管人员可通过移动端低空卫士APP，精准识别定位附近无人机位置与飞手位置，该无人机的电子牌照、型号、高度等其他信息也将同步至低空有效监视平台发出预警。通过“地空联动定位”，实现“发现-定位-处置”的全流程快速响应，有效解决难以锁定无人机飞手的问题。在现场各部门的合力协同下，成功侦测到3起无人机事件。<p>' +
      '</p>' +
      '自国内低空空域管理改革推进以来，忆伯科技深度参与低空领域的创新实践，致力于为直管部门构建智慧化、立体化的低空安全管理体系，已广泛应用于全国各地重大安保活动，在一线巡逻实战任务中取得良好的实战效果。我司将持续深耕低空管制领域，进一步提升低空空域利用效率和管理水平，助力推动低空经济的持续发展。<p>' +
      '</p>',
    date: '2025.05.09',
    des: '4月下旬，忆伯科技为某省市自行车赛活动全程做好低空安全保障工作。',
    cover: '/news/new30.png',
  },
  {
    id: 29,
    title: '忆伯科技为某省级庙会活动构建低空有效监视系统与平台解决方案',
    content:
      '<h3>一、方案背景</h3><p>' +
      '近年来，随着中央到地方支持政策的密集出台，低空经济的发展赛道日益开阔。基于无人机的数量呈现爆发式增长，种类日益繁多，无人机在未经授权等情况下飞入防控区域，使得直管部门发现难、管理难，严重扰乱了低空交通的正常秩序。<p>' +
      '</p>' +
      '某省级庙会活动作为重大文化活动，对传承地域文化、促进文旅融合、推动地方经济发展以及丰富民众精神生活具有重要意义，累计接待百万游客。针对该类重要重大安保活动，基于人群密集、规模宏大、周期长、社会影响大等诸多痛点，需严格保证低空安全有序的环境。通过在活动期间构建立体化、智能化、服务化的低空有效监视系统，对入侵无人机目标进行监视预警、精准定位、追踪线索，帮助直管部门更快、更有效的应对突发情况，显著降低因“低、慢、小”飞行目标所带来的各种潜在风险，确保重大安保活动的顺利进行。<p>' +
      '</p>' +
      '<h3>二、需求痛点</h3><p>' +
      '</p>' +
      '1）沿线交通复杂<p>' +
      '</p>' +
      '活动期间，大量人员聚集，且活动花车队伍较长，极大加剧了沿线交通的复杂性。若发现非配合无人机随意在活动区域内飞行时，可能造成人群恐慌和安全隐患，影响活动的正常秩序，不利于现场安保人员进行管理和应对突发情况。<p>' +
      '</p>' +
      '2）监视覆盖难<p>' +
      '</p>' +
      '基于现场环境错综复杂，活动区域范围广阔，周围建筑物密集，为信号覆盖带来了较大挑战，可能存在监控信号盲区，需根据实际情况在合适的点位进行设备部署，对无人机目标的精准管控，才能实现对整个低空防控区域的全面监控。<p>' +
      '</p>' +
      '<p>' +
      '3）响应执行难</p>' +
      '活动涉及多个管理部门，面对无人机黑飞、违规操作等问题，由于缺乏高效统一的信息共享机制，致使信息流通存在阻碍。当出现突发情况时，各部门可能存在共享信息不及时、不充分，需耗费较长时间层层上报传递，较难详细快速达成共识并制定处置方案，使得在低空管理方面协同效率较低。' +
      '</p>' +
      '<h3>三、方案亮点</h3><p>' +
      '</p>' +
      '本方案由无人机远程识别等侦测设备和低空有效监视管理平台组成，旨在打造“监视-预警-处置”于一体的低空管控与服务平台系统。在活动现场及周边部署无人机远程识别设备，实时接收低空飞行数据并发出警告，通过低空有效监视平台协同直管人员完成管制任务，采取进一步的处置措施，确保省级庙会活动在安全有序的低空环境下顺利进行。<p>' +
      '</p>' +
      '1）沿线全面部署，实时监测<p>' +
      '</p>' +
      '本方案采用密集网格化部署，着重强调对活动沿线的全方面信号覆盖。通过沿线设置点位，在核心管控区域架设无人机远程识别地面站，沿途两侧配备便携式无人机识别肩灯，形成一张低空监测网络，从而降低监控盲区的潜在风险。设备全天候侦测解析低空的飞行状况，一旦发现无人机目标，将同步上传至低空有效监视管理平台，平台以清晰、可视化的方式呈现上报的无人机数据，以确定无人机的位置、型号、速度、高度、飞手位置等关键信息。<p>' +
      '</p>' +
      '2）有效识别与预警，及时处置<p>' +
      '当无人机目标进入防控区域时，设备能够实时准确地识别无人机的飞行数据，同时侦测多架无人机信息，低空有效监视管理平台将立即触发预警机制，以弹窗和报警声等多维度手段，提示已发现无人机事件，全程自动跟踪该目标的飞行轨迹，通过平台的视频回放功能，为直管人员提供完整的处置线索。</p>' +
      '<p>' +
      '3）多样化监测手段，高效协同</p>' +
      '除了无人机远程识别地面站等固定式设备外，在重大安保活动及日常巡逻巡检过程中，在不增加额外任务负担的情况下，直管人员可佩戴便携式无人机识别肩灯，根据实际需求进行部署调整，深入现场排查安全隐患。同时，配合移动端低空卫士APP，低空卫士APP内的高清地图直接锁定无人机以及飞手的位置、肩灯设备等信息，具备操作简易、部署灵活、可实施性高等优势，有助于把握低空的全局态势，有力保障低空防控的安全与秩序。' +
      '</p>' +
      '<h3>四、方案概述</h3><p>' +
      '</p>' +
      '忆伯科技为某省级庙会活动提供低空有效监视系统与平台解决方案，通过实现全方位的立体化管制目标，构建起“沿线部署—识别预警—有效监视—快速响应”的闭环低空监管架构，统筹建设好立体交通管控数字底座，有效遏制无人机“黑飞”乱象。<p>' +
      '</p>' +
      '低空安全管控不仅仅靠技术堆砌，更需要持续优化的创新管理手段。我司将持续扎根低空管控领域，加快建设国内低空立体交通网络，不断拓展技术和方案以适应更多的低空管控应用场景，深入了解各行业客户的重点需求，助推低空经济高质量安全发展。<p>' +
      '</p>',
    date: '2025.04.30',
    des: '本方案旨在打造“监视-预警-处置”于一体的低空管控与服务平台系统。',
    cover: '/news/new29.png',
  },
  {
    id: 28,
    title: '精准防控无人机黑飞！忆伯科技肩灯保障中超足球赛低空安全',
    content:
      '4月20日晚间，继沪上“德比”点燃黄浦江畔后，上海海港与成都蓉城的对决在浦东足球场顺利落幕。为进一步加强大型活动现场的空中安全秩序，杜绝因无人机“黑飞”情况造成的安全隐患，忆伯科技配合上海浦东警方织起立体低空“安全网”，全方位保障赛事有序进行。<p>' +
      '</p>' +
      '浦东警方根据安保预案，以“分区域、定岗位、明职责”为原则，联合忆伯科技无人机远程识别部署管理方案，共同构建起一套严密的三级防护网络体系——“核心管控区-周边疏导区-远端分流区”。通过现场部署低空有效监视管理平台，并与球场外围巡逻民警所配备的便携式无人机识别肩灯设备形成联动，在全市范围内率先打造了从“精准发现‘黑飞’行为”到“追踪并定位飞手”的全链条技术闭环，为赛事低空安全提供了全面的管制规划。<p>' +
      '</p>' +
      '据悉，在不久前的进行的上海“德比”大战中，一名未经报备、未实名注册的无人机“黑飞”飞手被当场发现查获。当晚20时50分许，现场部署的低空有效监视管理平台发出警报：一架未经报备的无人机正侵入浦东足球场上空。在发现该情况后，正在外场巡逻的民警立即启动肩灯，与平台双重锁定该“黑飞”无人机以及飞手位置，将正在浦东足球场一处停车场内操控无人机的飞手查获，及时制止了其“黑飞”行为。<p>' +
      '</p>' +
      '我司自主搭建的低空有效监视管理平台实现了对空域的全面动态监视，实时侦测低空飞行目标的经纬度位置、电子牌照、机型型号、速度、高度以及飞手位置等信息。在发现无人机后，肩灯立刻发出蜂鸣声提示，现场直管人员可以通过配套的低空卫士APP精准定位无人机和飞手位置，形成“平台+肩灯”的双系统数据融合。<p>' +
      '</p>' +
      '该低空管制方案进一步解决了“查机不追人”、线索获取不及时、处置响应慢等问题，展示了我司在各类大型安保场景的技术优势。未来，忆伯科技将继续以健全国内低空管理体系为发展目标，筑牢低空空域的安全防线，为维护公共安全和低空交通秩序工作提供可靠的技术支持与服务。<p>' +
      '</p>',
    date: '2025.04.24',
    des: '4月20日，忆伯科技配合上海浦东警方全方位构建低空防护网络',
    cover: '/news/new28.png',
  },
  {
    id: 27,
    title: '忆伯科技便携式无人机识别肩灯，全力筑牢乐山低空安全防线',
    content:
      '3月15日，乐山犍为第五届半程马拉松赛在犍为县城区举行。据悉，本届比赛设半程马拉松（21.0975公里）和欢乐跑（5公里）两个项目，共有来自全国各地的10000余名跑步爱好者欢聚于此。<p>' +
      '</p>' +
      '为确保赛事期间道路交通安全有序，乐山公安对部分道路实施交通管制，同时对进行无人机等“低慢小”航空器飞行活动进行临时管控。根据《无人驾驶航空器飞行管理暂行规定》、《民用无人驾驶航空器系统空中交通管理办法》等法律法规规定，禁止一切单位、组织和个人在临时管制区域进行无人机等航空器飞行活动。对于其他性质的飞行活动，应当经军队、民用航空中管制部门批准后，方可进行。<p>' +
      '</p>' +
      '针对赛事规模大、观众多且周边道路复杂的挑战，我司配合乐山公安圆满完成了赛事期间的低空安全防控任务。乐山公安在临时管控区域架设1台远程识别地面站作为整个防控体系的核心节点。同时，沿着全程赛道的关键点位，安排了多名执法人员携带12套便携式无人机识别肩灯设备进行实时监测，全面覆盖赛事现场及周边的低空区域，将监管模式由“被动等待、事后追查”升级为“主动获取，及时处置”，增强了赛事期间的整体安全保障水平。<p>' +
      '</p>' +
      '通过我司自研的远程识别地面站实时接收无人机识别信息，在城市范围内可侦测1-5km的空域情况（具体覆盖范围取决于环境和机型），实时将数据同步至平台，从而触发报警提示。<p>' +
      '</p>' +
      '肩灯以轻量化设计保证携带便利性，探测范围达到600-800米半径,通过蜂鸣声提醒执法人员，随即启动联勤联动机制，在锁定无人机的识别号、位置、飞行轨迹以及飞手位置等关键数据后，执法人员可立刻前往现场处置。<p>' +
      '</p>' +
      '无人机数量的激增对国内无人机实时监管能力提出了要求。忆伯科技将进一步推动我国无人机监管数字化模式，持续优化一体化低空管理平台协同监管体系，及时发现潜在飞行隐患，实现对低空空域交通的全面监控和数据追溯，为国家、政府和直管部门提供强有力的技术支撑，确保低空领域的安全秩序。<p>' +
      '</p>',
    date: '2025.04.07',
    des: '3月15日，忆伯科技与乐山公安合作，圆满完成乐山犍为第五届半程马拉松赛低空防控任务。',
    cover: '/news/new27.png',
  },
  {
    id: 26,
    title: '忆伯科技便携式肩灯配套应用上线，全面贯彻低空勤务精细化管理目标',
    content:
      '为进一步落实国家对低空空域管理改革的要求，低空资源正在逐步被开发。据统计，2024年我国新增实名登记无人机110.3万架，累计完成无人机飞行2666万小时，同比增长了15%。无人机技术的应用场景得以极大的拓展，使得无人机的使用需求更为多元化。然而，无人机飞行数量的急剧攀升，引发了潜在的滥用、黑飞等现象，使得管理部门面临安全挑战。<p>' +
      '</p>' +
      '2024年，忆伯科技与南京市公安局江北分局共同创立了低空管控识别技术联合创新中心。为解决低空管理问题，合作研发了便携式无人机识别肩灯，并开发低空卫士APP配套无人机远程识别部署管理方案，通过联勤联动的方式，为城市治理和低空交通管理注入新动力。目前，南京市公安局江北分局已将该肩灯投入日常执行任务使用。<p>' +
      '</p>' +
      '<h3>地面站+平台，精准定位无人机</h3><p>' +
      '</p>' +
      '我们认为要大力发展低空经济，必须将低空安全置于首位。当前，无人机在人口密集的区域黑飞现象频发，严重扰乱了空中交通秩序和公共安全。由于低空与地面之间交互联动具有复杂性，需要完善基础设施体系作为支撑。为此，忆伯科技自主研发了无人机远程识别地面站，搭建低空安全管理平台，协助国家、政府、管理直辖部门提高低空管制的处置效率，完善国内综合低空立体交通管理系统。<p>' +
      '</p>' +
      '本方案采用网格化部署方式，通过无人机远程识别地面站接收无人机的飞行信息，同步至低空安全管理平台，包括无人机的电子牌照、经纬度位置、速度、高度、飞手位置等信息。无人机远程识别地面站符合国家标准《民用无人驾驶航空器系统安全要求》（GB42590-2023）的规定，城市郊区环境可探测1-5公里(取决于环境和机型)，贯彻全区域精细化空域管理的目标。<p>' +
      '</p>' +
      '低空安全管理平台现已接入5G-A、RID、ADS-B、AIS、图传解析等数据源，通过勤务联动的方式精准定位无人机的飞行位置和飞行轨迹，实时监控监管区域并以声光方式发出事件告警，支持事后回放、电子围栏、设备管理、无人机白名单、统计报告等核心功能，能够及时通知管理人员进行处理。本平台将全面提升空域管理水平，确保低空空域交通的安全和有序。目前已在重庆市万州区成功部署第一期设备（30多台）并投入当地公安部门常态化运营。<p>' +
      '</p>' +
      '<h3>一肩章一应用，维护现场低空安全</h3><p>' +
      '</p>' +
      '2024年10月，南京江北新区警方在南京青奥体育公园某演唱会开展安保期间，为确保低空空域安全，江北公安低空勤务保障中心为执勤警力架设一个便携式基站设备，为两组机动巡逻警力各配备一个多功能低空识别肩灯。<p>' +
      '</p>' +
      '演唱会开场前夕，便携式基站设备和多功能低空识别肩灯同时发现一架黑飞无人机，便携式基站设备通过平台端提示报警，多功能低空识别肩灯通过蜂鸣报警。机动巡逻警力迅速通过低空卫士给出的飞手动态位置，2分钟内就在河边将边飞边离开的当事人找到，民警迅速控制无人机落地，并对当事人身份和无人机登记等信息进行核查，确认不存在其他违法行为后，对其开展法制宣传，并在批评教育后劝离。<p>' +
      '</p>' +
      '可见在大型安保活动及重要防控区域内，低空区域的现场临时布控也至关重要。该肩灯作为单警装备，主要用于接收无人机远程识别信号，具备常规肩灯功能，重量轻便，方便携带，探测范围可达600-800米半径，根据不同的工作模式可续航5-24小时。<p>' +
      '</p>' +
      '在肩灯与低空卫士APP连接后，当发现附近有无人机飞行时，肩灯将发出警示蜂鸣声，执法人员即可通过低空卫士APP的消息提示同步跟踪查看该无人机的位置和飞手位置，便于执法人员第一时间前往现场，为进行进一步的处置措施提供数据证据。<p>' +
      '</p>' +
      '为应对多变的低空航行环境，优先建立国内低空交通网络，可大幅提升全国各区域之间的经济协同发展和资源优化配置。忆伯科技专注于提供精确、可靠的综合监管方案，推动建设低空空域协同管理机制，加快基础设施部署与系统的搭建，助力国内实现精细化布局和动态化管理。忆伯科技将不断完善“管理、服务、处置”为一体的数字化底座，为各行业客户提供更多融合多应用场景的低空管制解决方案，为低空空域的合理利用和低空经济的发展提供有力支撑。<p>' +
      '</p>',
    date: '2025.01.23',
    des: '忆伯科技与南京市公安局江北分局合作研发便携式无人机识别肩灯。',
    cover: '/news/new26.png',
  },
  {
    id: 25,
    title: '忆伯科技受邀出席上海无人机协会2024年度总结表彰大会',
    content:
      '12月27日，上海市无人机安全管理协会召开2024年总结表彰会，忆伯科技作为协会会员受邀参会。会上总结了2024年整体工作，规划了2025年工作计划，鼓励会员企业创新发展，表彰在安全、研发、技术、应用等领域取得的成果。一直以来，忆伯科技致力于通过技术创新以推动低空行业高质量发展，在这次评选中，我司荣膺2024年度“科技之星”奖项。<p>' +
      '</p>' +
      '回顾2024年，作为“低空经济元年”，政策环境的持续优化，产业需求的繁荣壮大，让低空经济从概念走向了现实。其中，技术的层层突破更是为低空经济的发展注入了重要力量。忆伯科技为提升低空监管部门对无人机的跟踪和管理能力，已将无人机远程识别技术（Remote ID）、5G-A通感一体等综合技术手段接入低空安全管理平台，实现对无人机飞行轨迹、速度、经纬度等飞行数据精确感知，建设无人机管理“监、管、服”三位一体的无人机综合体系。<p>' +
      '</p>' +
      '展望2025年，将是低空产业发展全面提速之年。忆伯科技将保持科技创新高水平能力，为广大客户提供更为高效、安全的低空空域服务系统与方案，因地制宜地融合空天地立体交通网络，全面助力推进国内低空空域管理改革工作。<p>' +
      '</p>',
    date: '2025.01.06',
    des: '12月27日，忆伯科技受邀参加上海市无人机安全管理协会召开2024年总结表彰会。',
    cover: '/news/new25.png',
  },
  {
    id: 24,
    title: '忆伯科技参加2024世界智能制造博览会，全面推动低空交通国产化',
    content:
      '12月20日至22日，忆伯科技参加2024世界智能制造博览会。本次展会聚焦智能制造领域先进技术产品、系统解决方案和行业示范应用等，首次引入低空经济和商业航天元素。展会现场吸引了5万人次专业观众，为数字智能产业构建一个多元化、国际化、专业化的全球智能制造交流合作平台。<p>' +
      '</p>' +
      '2024年，忆伯科技与南京市公安局江北分局共同创立了低空管控识别技术联合创新中心。为解决低空管理问题，合作研发了便携式无人机识别肩灯，并开发低空卫士APP配套无人机远程识别部署管理方案，通过联勤联动的方式，为城市治理和低空交通管理注入新动力。目前，南京市公安局江北分局已将该肩灯投入日常执行任务使用。<p>' +
      '</p>' +
      '忆伯科技以低空管控的方案定位出发，向参展同行与观众展示无人机远程识别系列最新产品，共同探讨智能制造未来市场走势。我司致力于通过综合监测技术手段，提升低空环境的安全性，实现对低空空域的动态监控。在无人机装配远程识别发射模块或飞手小方后，通过远程识别地面站接收远程识别信号，并配套低空安全管理平台，精确识别与跟踪无人机的飞行状态，具备事后回放和事件分析等功能，记录飞行数据证据，帮助监管部门快速处理入侵事件。<p>' +
      '</p>' +
      '无人机滥用和未经授权操作的情况增多，空中交通管理的压力随之增加。无人机远程识别部署方案针对低空管理的需求，通过综合技术手段全方面掌握低空飞行动态，快速建立数据收集分析系统，为国家、政府和相关监管部门的第一决策提供有效的数据和技术支持。产品主要包括无人机远程识别地面站、低空无线电侦测解析地面站、无人机外挂模块、无人机远程识别模块、无人机远程识别接收端模块等。<p>' +
      '</p>' +
      '伴随着新一代数字技术迅猛发展，将深刻推动技术效率革命。忆伯科技作为推动科技国产化的一员，将继续保持从研发、生产和服务等多个维度实现全面创新，为客户提供全方位、个性化的低空解决方案，为国内低空立体交通领域迈向新的高峰贡献力量。<p>' +
      '</p>',
    date: '2024.12.23',
    des: '12月20日至22日，忆伯科技携低空管理方案参加2024世界智能制造博览会。',
    cover: '/news/new24.png',
  },
  {
    id: 23,
    title: '喜报丨忆伯科技荣获上股交2023年度“市场贡献突出企业”奖',
    content:
      '上海股权托管交易中心是经上海市人民政府批准、中国证监会备案区域性股权市场。2023年，上海股权托管交易中心在习近平新时代中国特色社会主义思想的指导下，全面贯彻落实党的二十大和二十届二中全会精神，深入学习习近平总书记考察上海重要讲话精神，为更进一步激发市场参与主体积极投身建设上海国际金融中心和科创中心的伟大事业而特设了16类奖项。<p>' +
      '</p>' +
      '上海股权托管交易中心是经上海市人民政府批准、中国证监会备案区域性股权市场。2023年，上海股权托管交易中心在习近平新时代中国特色社会主义思想的指导下，全面贯彻落实党的二十大和二十届二中全会精神，深入学习习近平总书记考察上海重要讲话精神，为更进一步激发市场参与主体积极投身建设上海国际金融中心和科创中心的伟大事业而特设了16类奖项。<p>' +
      '</p>',
    date: '2024.12.18',
    des: '忆伯科技凭借卓越的创新能力和优秀的市场表现，荣获上海股权托管交易中心2023年度“市场贡献突出企业”奖。',
    cover: '/news/new23.png',
  },
  {
    id: 22,
    title: '忆伯科技携远程识别热销产品亮相2024上海无人机展',
    content:
      '11月28日至30日，忆伯科技受邀参加2024上海无人机系统技术展览会。大会以“共创低空，融合创新”为主题，以“展会+论坛”的形式搭建开放合作，旨在共同推动低空产业高质量发展。近年来，我国低空经济发展加快，空域管理成为了我国发展低空经济的关键之一。忆伯科技在本次大会集中展示了无人机远程识别管理部署方案及自主研发的通用航空系列产品，积极呼应我国低空管控领域的核心竞争力的提升。<p>' +
      '</p>' +
      '为解决无人机滥用、黑飞和未经授权操作的问题，无人机远程识别部署方案以有效识别飞行阶段的无人机、降低航空活动的碰撞风险为目的，协助国家、政府、相关直管部门进行低空管控。在无人机远程识别地面站网格化部署后，通过接收、处理、转发无人机远程识别信号，同步监控中心的无人机管理平台对入侵目标实时预警，并记录和分析无人机的序列号、机型、经纬度、速度、高度、飞行轨迹等信息。该方案不仅增加了低空管制能力和处置效率，更提高了低空飞行活动的安全性。<p>' +
      '</p>' +
      '大会期间，忆伯科技针以开放的态度，与各位业界同仁及广大观众对产业发展的热点与痛点问题进行深度交流和思想碰撞，分享低空技术的最新经验与成果。忆伯科技将恪守创新精神，深耕低空技术领域，紧密契合国家空域政策导向，鼎力支持并推动国家低空经济的繁荣与发展。<p>' +
      '</p>',
    date: '2024.12.02',
    des: '11月28日至30日，忆伯科技受邀参加2024上海无人机系统技术展览会。',
    cover: '/news/new22.png',
  },
  {
    id: 21,
    title: '搭建新质“千里眼”，忆伯公司助力万州低空经济“飞”得更稳更远',
    content:
      '针对当前低空经济高速发展，无人机“黑飞”严重影响公共安全，如何快速发现无人机和锁定无飞手成为当前监管的重要环节。上海忆伯科技股份有限公司自主研发的远程识别接收器，实现对探测区域内所有无人机的远程识别信号进行全面捕捉。<p>' +
      '</p>' +
      '目前，公司与万州公安、中国移动万州分公司深度合作，率先创新RID与5G-A形成互通互补，能够全方位探测无人机和锁定飞手位置，形成了一张低空防护网，破解了当前“黑飞”难找的难题；另外，万州公安已启用无人机号牌并发放300余个，成为全国首创。目前，万州已安装5G-A设备3台、RID设备20余台，已覆盖全城区；其中，万州机场已安装4台设备，成为了西南地区第一家。<p>' +
      '</p>' +
      '同时，万州公安与公司共同研发了低空安全管理平台，能实时上传入侵无人机的飞行数据，包括无人机ID、飞行高度、经纬度、飞行速度、飞行轨迹、飞手位置等信息，从而实现了对无人机活动的全方位立体化管理。该设备和平台在演唱会安保、自行车比赛等大型活动安保护航助力明显；日常探测已发现万州城区无人机飞行1296架次，为辨别处置提供了支撑。<p>' +
      '</p>',
    date: '2024.11.08',
    des: '我司与万州公安、中国移动万州分公司深度合作，破解了当前“黑飞”难找的难题。',
    cover: '/news/new21.png',
  },
  {
    id: 20,
    title: '忆伯科技受深圳无人机协会邀请参加第二届低空经济（苏州）博览会',
    content:
      '10月18日至20日，忆伯科技受深圳无人机协会邀请参加第二届全国低空经济（苏州）产业创新博览会。本次展会以“翼展低空 领航未来”为主题，旨在推动领军企业、优质项目对接落地，构建携手共进、合作共赢的低空经济生态圈。<p>' +
      '</p>' +
      '当前低空经济的发展趋势，重点关注技术的实际融合与应用。忆伯科技通过这次集理论研讨与创新展示于一体的低空经济产业交流协作平台，向同行和观众全面展示了无人机远程识别部署方案及低空管制的科技成果。<p>' +
      '</p>' +
      '无人机滥用和未经授权操作的情况增多，空中交通管理的压力随之增加。无人机远程识别部署方案针对低空管理的需求，通过综合技术手段全方面掌握低空飞行动态，快速建立数据收集分析系统，为国家、政府和相关监管部门的第一决策提供有效的数据和技术支持。产品主要包括无人机远程识别地面站、低空无线电侦测解析地面站、无人机外挂模块、无人机远程识别模块、无人机远程识别接收端模块等。<p>' +
      '</p>' +
      '我司自主研发的无人机远程识别地面站是一款用于接收无人机远程识别信号的设备。通过范围部署远程识别地面站，实时检测、识别和管理无人机的飞行状态，接收包括无人机的序列号、型号、速度、高度、飞手位置、飞行轨迹等信息，同步至云端的可视化低空安全管理平台，协助监管机构高效管理低空领域，确保空中安全与秩序。<p>' +
      '</p>' +
      '展会虽已圆满落幕，我们依然在持续目睹着低空产业技术的飞速进步。忆伯科技作为低空经济产业的一份子，将继续发挥全国产化的优势，深耕技术创新，优化产品体系，以更高的标准、更优的品质，携手行业同仁，共同推动低空经济产业的创新发展。<p>' +
      '</p>',
    date: '2024.10.21',
    des: '10月18日至20日，忆伯科技受深圳无人机协会邀请参加第二届全国低空经济（苏州）产业创新博览会。',
    cover: '/news/new20.png',
  },
  {
    id: 19,
    title: '喜报！我们的ADS-B载荷上天啦！',
    content:
      '2024年9月24日10时31分，忆伯科技研制的ADS-B载荷，在山东海阳卫星发射中心搭载捷龙三号运载火箭顺利发射升空，航天器成功进入预定轨道，各项参数正常。目前，载荷已经进入在轨测试阶段。<p>' +
      '</p>' +
      '忆伯科技研制的星载ADS-B成功入轨后，可对全球空域进行实时监控，不仅覆盖面积大，运营成本低，更能提高空域的安全性、使用效率等。<p>' +
      '</p>' +
      '由此，忆伯科技正式踏入航天领域，实现了对空天地海的全面覆盖。忆伯科技也将继续深耕ADS-B等技术，不断提升科技研发创新力，夯实自身优势，为各行业的客户提供高效的解决方案。<p>' +
      '</p>',
    date: '2024.09.27',
    des: '2024年9月24日10时31分，忆伯科技研制的ADS-B载荷顺利发射升空。',
    cover: '/news/new19.png',
  },
  {
    id: 18,
    title: '忆伯科技受邀参加2024重庆低空经济产业博览会',
    content:
      '8月14日，2024中国航空航天科普展览会暨中国（重庆）低空经济产业博览会顺利举行。博览会集中展示了我国航空领域的最新科技成果、先进装备以及低空经济产业的发展。<p>' +
      '</p>' +
      '本次展会忆伯科携自主研发的无人机远程识别系列产品，包括低空无线电侦测解析地面站、无人机远程识别接收器、飞手小方、无人机远程识别嵌入式模块、无人机远程识别接收模块等，旨在紧跟低空消费、低空运营服务等全产业链的融合发展趋势。<p>' +
      '</p>' +
      '展会中首次亮相了低空无线电侦测解析地面站，是集无人机远程识别、飞控链路协议解析、ADS-B、AIS于一体。其中的无人机远程识别模块由四个无线电接收通道组成，用于接收远程识别信号，接收协议符合国际标准。此外，飞手小方作为无人机远程识别外挂模块已获得了FAA美国联邦航空管理局的认证，其轻巧体量可通过蓝牙广播及WiFi信标广播无人机位置信息。<p>' +
      '</p>' +
      '忆伯科技将充分发挥自身国产化优势，持续深化和拓展低空应用场景，推动低空产品和服务大众化发展，协同各地区监管部门建立无人驾驶航空器监管机制和安全监管体系，全面助力国内低空现代化建设。<p>' +
      '</p>',
    date: '2024.08.20',
    des: '8月14日，忆伯科技参加2024中国航空航天科普展览会暨中国（重庆）低空经济产业博览会。',
    cover: '/news/new18.png',
  },
  {
    id: 17,
    title: '上海市无人机安全协会与忆伯科技座谈交流',
    content:
      '7月3日，上海市无人机安全管理协会与忆伯科技就无人机运行功能识别技术等事宜开展了座谈会。上海市无人机安全管理协会会长王旭明，协会副秘书长王凌峭，会员服务部主任吴珺，上海忆伯科技股份有限公司总经理徐伯胜，副总经理张佳骏，技术专家李云川一同参与座谈交流。<p>' +
      '</p>' +
      '会上，王旭明会长对我司一行人员到访表示欢迎，徐伯胜总经理感谢协会的关心和指导。忆伯科技为响应低空领域国家文件要求，自主研发无人机远程识别产品，瞄准低空监管难题，实现对无人机及其飞手的远程识别和定位跟踪，详细介绍了包括无人机远程识别接收器、无人机监测平台等产品优势和平台应用的情况。<p>' +
      '</p>' +
      '伴随着无人机行业的蓬勃发展，忆伯科技将着力解决低空监管应用中的行业性难题，确保核心技术的自主可控，持续提升技术先进性，构建多层次、全方位的低空治理体系，努力成为低空监管领域的领跑者，为国家低空空防挖掘更多技术潜力。<p>' +
      '</p>',
    date: '2024.07.04',
    des: '7月3日，上海市无人机安全管理协会与忆伯科技就无人机运行功能识别技术等事宜开展了座谈会。',
    cover: '/news/new17.png',
  },
  {
    id: 16,
    title: '忆伯科技与浙江联通战略签约仪式成功举行',
    content:
      '6月，忆伯科技与中国联通浙江分公司举行签约仪式达成重要战略合作。<p>' +
      '</p>' +
      '6月，忆伯科技与中国联通浙江分公司举行签约仪式，深化探讨合作细节，就低空监管领域达成重要战略合作。<p>' +
      '</p>' +
      '双方着眼无人机远程识别领域的交流与合作，尤其着重于无人机远程识别的精准性及拓展低空应用领域的广阔潜能，旨在矢志共探共践，开创新局。忆伯科技根据国标GB 42590-2023自主研发的无人机远程识别产品，能够识别飞行阶段的无人机，从而提高低空飞行活动的安全性，实现空域实时监控与高效调度。<p>' +
      '</p>',
    date: '2024.06.25',
    des: '6月，忆伯科技与中国联通浙江分公司举行签约仪式达成重要战略合作。',
    cover: '/news/new16.png',
  },
  {
    id: 15,
    title: '忆伯科技与中国电信携手率先完成国内无人机远程识别基站部署',
    content:
      '5月，我司与上海电信移动互联网部和宝山电信局达成战略合作，并率先完成基站部署。<p>' +
      '</p>' +
      '在无人机产业链全球化的大背景下，科技创新是引领国家发展的第一动力。为筑牢低空飞行安全的体系建设，5月，我司与上海电信移动互联网部和宝山电信局共同合作，率先完成了国内无人机远程识别基站的部署，现已迈入商业运营阶段。<p>' +
      '</p>' +
      '目前，我司与中国电信的战略合作受到了广泛的关注与认可，多家主流媒体纷纷进行了报道。此次合作深度融合双方技术、市场及应用优势，显著增强低空技术与安全标准，旨在为无人机远程识别领域树立了合规标杆。<p>' +
      '</p>' +
      '面对日益增长的低空空域管理需求，远程识别基站的全国产化研发之路，正是对国家低空管控政策与远程识别法规的积极响应。无人机远程识别基站由多个无线电接收通道组成，用于接收远程识别信号，能够接收符合国标GB 42590-2023要求的广播类型。远程基站的拓展部署将全方面掌握区域内无人机的飞行动态，快速建立数据收集分析系统，为无人机的实际管理决策和突发情况提供有效技术支持，以普及和适应更多应用场景。<p>' +
      '</p>' +
      '无人机远程识别基站如同无形的防护网，将成为连接低空安全与低空经济发展的重要桥梁。忆伯科技将继续专注构筑低空安全管控的发展方向，推动智慧空中交通建设及低空经济的蓬勃兴起铺设技术基石，为我国科技发展注入更为强劲的自主实力。',
    date: '2024.06.17',
    des: '5月，我司与上海电信移动互联网部和宝山电信局达成战略合作',
    cover: '/news/new15.png',
  },
  {
    id: 14,
    title: '忆伯科技圆满参展2024深圳国际无人机博览会',
    content:
      '5月24日至26日，备受瞩目的第八届世界无人机大会暨2024国际低空经济与无人系统博览会在深圳会展中心盛大启幕。本次展会以“低空经济 未来已来”为主题，围绕无人机与低空经济，低空数字交通，低空飞行服务，eVTOL技术创新与应用等主题，共同探讨低空经济发展与无人系统的智能化应用，产业落地和未来发展趋势。<p>' +
      '</p>' +
      '忆伯科技为持续深入拓展无人机系统的创新应用，推动低空经济健康有序发展，作为无人机运行识别和无人载具自动避碰方案商，首次全方位公开展示自主研发的运行识别系列产品，包括远程识别模块、远程识别外挂模块、远程识别嵌入式接收器、远程识别地面接收站等产品。<p>' +
      '</p>' +
      '其中，远程识别部署管理方案在展会现场受到广泛关注。本方案以识别飞行阶段的无人机为目的，针对不断增长的无人机数量和飞行活动的需求，通过综合技术手段对无人机进行实时监测、识别和管理，监控中心涵盖远程识别、实时数据传输、预警和警告、记录和分析等功能，解决低空管制的效率，提高低空飞行活动的安全性。<p>' +
      '</p>' +
      '展会期间，忆伯科技与与国内外行业人员进行了深入交流，共同探讨国内外无人机前瞻技术的发展趋势，旨在携手推进低空经济生态圈的建设与发展。<p>' +
      '</p>' +
      '“低空经济”已成为推动国内经济增长的重要动能，预示着一个充满无限可能的“未来已来”。忆伯科技将持续深剖无人机相关技术的革新和市场潜力，为低空发展的研究与决策提供稳固的技术支持，与行业精英共同搭建低空经济产业新布局。',
    date: '2024.05.31',
    des: '5月24日至26日，忆伯科技参加第八届世界无人机大会暨2024国际低空经济与无人系统博览会。',
    cover: '/news/new14.png',
  },
  {
    id: 13,
    title: '重庆某质检中心引进忆伯科技远程识别接收器',
    content:
      '2024年5月，重庆某质量检验检测中心引进了我司自主研发的无人机远程识别接收器，根据国标GB 42590-2023用以检测无人机的远程识别功能，目前该接收器已投入正常运行。该接收器的首次检测实践，旨在为无人机行业树立新基准，以增强无人机检测流程的规范化。<p>' +
      '</p>' +
      '通过无人机远程识别接收器中多个无线电接收通道的持续扫描，检测中心能够在无人机执行飞行任务的同时，收集并分析多项远程识别功能的关键指标，包括无人机的经纬度、高度、航速、飞手位置等信息，确保每一项检测符合国标规定，保证检测结果的客观性和准确性，为无人机制造商、运营商及监管部门提供了统一且权威的检测依据。<p>' +
      '</p>' +
      '低空经济是推动新质生产力发展的重要力量，低空应用是把握发展的核心要点。忆伯科技始终坚持以科技创新为核心驱动力，不断积累精进低空监管技术经验，做好动力引擎、当好开路先锋，矢志为低空经济蓬勃发展做出技术贡献，促进低空新时代开启无限可能',
    date: '2024.05.24',
    des: '2024年5月，重庆某质量检验检测中心引进了我司自主研发的无人机远程识别接收器',
    cover: '/news/13.png',
  },
  {
    id: 12,
    title: '忆伯科技赋能空域监管规划',
    content:
      '<p>导言</p>' +
      '<p>在国家着重发展低空经济的时代背景下，2024年4月，我司团队自主研发的运行识别地面站终于昂首迈入规模生产的新起点。凭借为低空监管部门提供无人机运行识别部署解决方案，以及运行识别技术与系统化的技术支撑，我司为无人机监管领域开创出一条全新的智能化路径。</p>' +
      '<p>空域规划引领赋能低空经济</p>' +
      '<p>基于低空经济是战略性新兴产业，呈现出明显的新质生产力特征。围绕产业链，无人机在应急管理、城市运行、物流运输等各个领域发挥着越来越重要的作用，为各行各业的创新发展注入了源源不断的活力。如何让无人机安全、有序的飞行？如何让低空经济在新规的框架下得到飞速发展，实现优化完善？这些“？”成为了低空管理部门当下的重要突破点。</p>' +
      '<p>空域规划是低空经济高飞的关键。已于2024年1月1日正式实施的《无人驾驶航空器飞行管理暂行条例》 以及2024年6月1日即将正式实施的《民用无人驾驶航空器系统安全要求》 ，明确了各部门的职责和协同管理的路径。低空经济已然成为多地产业规划的关键词，相关扶持政策陆续出台。</p>' +
      '<p>深耕无人机领域抢占变革先机</p>' +
      '<p>我司自投身无人机防避碰领域的研发与应用以来，始终以前瞻视野洞察行业趋势，积极响应国家对低空空域的规划与安全需求。而在无人机远程识别领域的持续探索与创新，是我们深入践行国家战略，助力构建低空经济体系，强化国防安全屏障的重要举措。</p>' +
      '<p>这一路走来，我们深知，发展低空经济不仅关乎国家安全战略的纵深布局，更是推动我国经济高质量发展的新增长极，这对于优化产业结构、促进区域协调发展、提升公共服务效能具有重大意义。低空经济的崛起将进一步激发科技创新活力，推动无人系统、物联网等前沿技术的深度融合，为我国在全球新一轮科技革命和产业变革中抢占先机。</p>' +
      '<p>科技驱动打造低空监管解决方案</p>' +
      '<p>我司推出的达到工业标准的无人机运行识别地面接收站一旦得到规模化拓展部署，利于及时接收、处理、转发无人机远程识别信息，监管部门能够快速通过勤务联动的方式找出违规无人机的位置进行反制或追踪至飞手，有效解决了空中交通有序管理，有力推动无人机运行识别国标规定的执行，实现了从理论构想到实际应用的大跃进。</p>' +
      '<p>我们依托对低空管控技术的深厚积淀，以无人机远程识别接收器为部署核心，打造安全、高效、智能的低空交通管理系统，满足和对接市场需求，以此推动低空经济相关标准制定、法规完善及产业链协同发展，为构建规范有序、充满活力的低空经济和技术突破贡献力量。</p>' +
      '<p>空域交通已不再局限于科幻遐想，而是现实世界中亟待把握的战略前沿。低空发展要秉持民航强国的战略导向，忆伯科技将继续以科技创新为引领，以空域监管为方向，深度融入国家低空经济发展大局，以实际行动为我国经济转型升级、科技自主自强、国防安全屏障筑牢贡献力量，共同书写低空经济繁荣发展的安全篇章。</p>',
    date: '2024.04.15',
    des: '2024年4月，我司团队自主研发的运行识别地面站终于昂首迈入规模生产的新起点。',
    cover: '/news/a5.png',
  },
  {
    id: 11,
    title: '忆伯科技受邀出席上海无人机安全协会第五次会员大会',
    content:
      '1月11日下午，忆伯科技受邀出席上海无人机安全管理协会隆重召开了第一届第五次会员大会暨第六次理事会、第五次监事会、2023年度表彰大会，共同探讨无人机引领低空经济发展新思路。<p>' +
      '<p>' +
      '此次会议以“安全 有序 健康 高效”作为四个关键词展开，对2023年协会工作进行了总结汇报，有序规划2024年的工作计划。旨在打通无人机产业生态圈、联动产业链上下游，探讨地区一体化发展策略，分享先进管理经验。<p>' +
      '<p>' +
      '无人机是第三次产业革命的热点。政府高度重视无人机行业的发展，陆续出台了一系列政策和支持措施。去年6月，国务院、中央军委颁布我国首个无人机专门管理法规《无人驾驶航空器飞行管理暂行条例》，对无人驾驶航空器从设计生产到运行使用进行全链条管理，为产业持续健康发展提供了法治保障，我国无人机产业应该抓住发展新机遇。<p>' +
      '<p>' +
      '作为无人机行业的一员，忆伯科技将在新的一年里，始终秉持着“技术驱动 业务支持 行业沉淀”的理念，积极推动无人机行业标准的建设，突破关键技术，研发重要飞行平台，为广大客户提供更多低空管控解决方案。',
    date: '2024.01.11',
    des: '1月11日下午，忆伯科技受邀出席上海无人机安全管理协会隆重召开了第一届第五次会员大会暨第六次理事会、第五次监事会、2023年度表彰大会。',
    cover: '/news/a4.jpg',
  },
  {
    id: 10,
    title: '忆伯科技正式研发无人机远程识别芯片',
    content:
      '<p>2018年4月，美国商务部公告，7年内禁止美国企业向中兴通讯出口任何技术、产品。其中，中兴的通讯模块、基带芯片、射频芯片等多类芯片均来自美国公司。</p>' +
      '</p>' +
      '2019年5月，华为作为全球知名的通信设备制造商，被美国联邦政府列入贸易管制清单。2020年美国官方又禁止任何公司使用美国技术或设备向华为提供半导体。由此芯片技术再次遭到封锁，暴露出当时中国在部分关键核心技术上受制于国外的软肋。<p>' +
      '</p>' +
      '2021年1月，即使是大疆这样引领全球无人机科技的厂商，基于美国企业在核心技术和零部件等方面对中国产业链的依赖极高，也被列入了美国禁止合作企业的名单中。<p>' +
      '</p>' +
      '2022年前后，美国政府便开始向荷兰、日本施压，要求全球最大的光刻机荷兰制造商ASML禁止向中国大陆出售制造全球大量芯片所需的主流技术。并在2024年宣布光刻机禁令，直接要求荷兰光刻机制造商ASML停止向中国出口某些型号的光刻机。<p>' +
      '</p>' +
      '</p>' +
      '这一系列全方位的制裁措施在很长一段时间内让中国企业感到不安，甚至让整个产业链产生了连锁反应。2018年以来，集成电路芯片“卡脖子”问题一直是我国产业发展之痛，美国对我国芯片产业发展的限制、打压和围堵，成为我国芯片技术和产业发展的严重障碍。<p>' +
      '</p>' +
      '我国保障现有和扩大先进制程芯片产能遭受了巨大影响，芯片制造企业的发展困难尤为突出。据统计，目前国内半导体上市公司里，70%实现盈利，30%处于亏损，整体净利润下降约54%，其中74%的公司净利润下降。光看芯片设计这一块，国内共有3243家芯片设计企业，55%的公司销售额不足1000万。<p>' +
      '</p>' +
      '一道道来自太平洋对岸的“禁令”，证明了一颗自主研发“芯片”的分量，也让国家意识到曾经的“至暗时刻”应由我们自己打破。从积极的方面来看，全球半导体行业正处于下行阶段，市场更具有话语权, 中国市场依然拥有宽阔的对外交流空间。芯片是半导体元件产品的统称，是信息安全时代的核心算力，是保障国家信息安全和推动经济发展的重要支撑。因此，研发高精尖技术芯片的艰辛之路必须坚持走下去。<p>' +
      '</p>' +
      '忆伯科技一直以来专注于空域及海域监控等领域，目前正在为国家低空管控领域研究无人机远程识别模块。这源于我们意识到低空领域的发展需要技术的持续升级，低空领域的安全更需要掌握在我们自己手里，无人机的远程识别方案最重要的部分就在于模块中核心的芯片。<p>' +
      '</p>' +
      '2023年，中国芯片进口量约为3977.1亿枚，但同比下跌达到了13.1%。据不完全统计数据显示，中国芯的自给率已经达到了23.3%，可见中国企业逐步降低了对美芯的依赖。<p>' +
      '</p>' +
      '通过调研我们发现，其他国家的航空监管机构早已提出了相关规定并强制使用，而市场上并没有适用于无人机远程识别的国产芯片。在研发过程中，我们意识到使用国外的芯片存在一定的国防空域安全风险。忆伯科技作为上海市无人机安全管理协会的一员，有责任为国内低空管制市场和监管部门提供硬软件方面的有力支持。<p>' +
      '</p>' +
      '忆伯科技的研发既是便于空中监管部门的管理，更快推动民用无人机应用集成到国家的空域管理体系中，更是为了中国空域、国防军工等重要板块在芯片领域能够拥有足够的底气和可观的国际地位，共同建构稳定的低空空域。<p>' +
      '</p>' +
      '“芯片战”是一场需要长期坚持、多方共同努力的战役。坚实的创新技术能力才是为中国无人机行业注入蓬勃生命力的关键。“路漫漫其修远兮，吾将上下而求索”。即便万事开头难，我们也需逆势而上，积极超越并掌握国际顶尖半导体技术。我司决定研发芯片彰显的是坚定捍卫中国空域主权的决心。<p>' +
      '</p>' +
      '忆伯科技将保持聚焦，瞄准无人机低空管控核心领域，解决自主可控问题，加快迭代研发和提供成熟的解决方案，充分利用国内市场优势，推动我国产业科技竞争力的水平。未来，我们将不断勇攀科技高峰，为无人机行业迈向更加辉煌的台阶而突围！\n',
    date: '2024.01.09',
    des: '基于中国芯片“卡脖子”问题，忆伯科技目前正式为国家低空管控领域研究无人机远程识别模块。',
    cover: '/news/new11.png',
  },
  {
    id: 9,
    title: '忆伯科技参加第十二届APEC中小企业技术交流暨展览会',
    content:
      '<p>2023年11月9日至11日，忆伯科技前往山东省青岛市参加第十二届APEC中小企业技术交流暨展览会（以下简称APEC技展会）并顺利落幕。APEC技展会是由工业和信息化部与山东省人民政府共同主办，以“绿色发展 数字赋能 融通创新 合作共赢”为主题，吸引了1600余家海内外企业参展参会。</p><p>' +
      '青岛政府的领导们高度重视本次APEC技展会开展的活动，亲自到场访问并在上海展区与各企业进行深度交流和指导。忆伯科技作为本次上海展区的参展商，与行业一同展示了中国的先进制造业和专精特新企业的发展成果，通过对产品展示和耐心讲解，让参展观众直观感受忆伯品质。</p><p>产品包括通用航空系列中的无人机远程识别模块、ADSR800（飞机外挂避碰），智慧城市系列中的工牌记录仪、智能头箍，船舶管控系列产品中的AIS-MOB（AIS个人便携应急示位标）、AIT33无人机/无人船AIS示位标等。</p><p>新形势下，和平发展、合作共赢是主流也是共识。忆伯科技将继续全力打造开放、立体、高质量的天地空一体化的解决方案及相关产品，创新智慧服务模式，一同促进亚太地区中小企业的创新发展和合作共赢，携手构建更加紧密的亚太命运共同体贡献积极力量。</p>',
    date: '2023.11.13',
    des: '2023年11月9日至11日，忆伯科技前往山东省青岛市参加第十二届APEC中小企业技术交流暨展览会（以下简称APEC技展会）并顺利落幕。',
    cover: '/news/new11.jpg',
  },
  {
    id: 8,
    title: '忆伯科技参与粤港澳大湾区建设',
    content:
      '<p>8月18日，珠江口船舶交通管理系统升级改造工程主体设备项目在广州顺利交工验收，标志着我国船舶交通管理系统自主建设能力全面提升。忆伯科技与中船鹏力信息公司协同合作国产化VTS（船舶交通服务系统）的构建，为粤港澳大湾区建设再添海上安全手段。粤港澳大湾区是我国经济活力最强、开放程度最高的区域之一，其具备牵引全面深化改革开放的基础。珠江口水网密布，航线密集，桥梁众多，被中国交通运输部列入全国“六区一线”重点监管水域，是世界上最为繁忙的通航水域之一，各口门断面日均总船舶流量达4000艘次。</p><p>忆伯科技参与中船鹏力信息公司研发的全国产化可双中心容灾切换的船舶交通管理系统的建构。忆伯科技自主研发的AIS系列产品，为该系统提供了技术支持，能够大规模覆盖粤港澳大湾区的百海里的水域。AIS系列产品配合GNSS定位系统，将船舶位置、船速、航向等船舶动态结合船名、呼号、吃水，船舶尺度及危险货物等船舶静态资料由甚高频(VHF)频道向附近水域船舶及岸台广播，有效避免船舶碰撞、减少人身安全和财产损失，实现船岸、信息联网、船舶信息共享。该系统将大幅提升珠江口水域水上交通安全能力，对全面对构建海事“陆海空天”一体化监管格局和深化海事全要素“水上大交管”建设有着重要意义</p><p>交通是兴国之要、强国之基。忆伯科技将坚持自立自强，坚持技术长征，突破技术难点，为客户提供并不断完善的海洋安全解决方案。</p>',
    date: '2023.08.18',
    des: '忆伯科技参与珠江口船舶交通管理系统升级改造工程主体设备项目在广州顺利交工验收。',
    cover: '/news/new10.png',
  },
  {
    id: 7,
    title: 'AIS-MOB V2.1 DEMO介绍',
    content:
      '<p>海上相关行业的繁荣发展必然伴随着海上事故的不幸发生，碰撞、侧翻沉没等情况所造成的人员和经济伤亡不容小觑。因此，精确定位落水人员的位置对海上救援来说格外重要。AIS（Automatic Identification System），是针对船舶的自动识别系统，主要有识别船只、导航、协助追踪目标、简化信息交流、通信以及提供其它辅助信息以避免碰撞发生的功能。AIS-MOB，全称AIS救生设备搜救信标，是针对海上救援的装备，不仅可安装在救生衣上使用，也可随身携带。忆伯科技针对海上生命安全，自主研发了AIS-MOB DEMO版，AIS-MOB DEMO主要采用GNSS定位系统，此板完成了AIS-MOB的所有功能，下面将详细展示AIS-MOB DEMO电路板的功能。</p><p>装置左上角最小的白色模块是闪光灯，下方黑色模块是一个85分贝的蜂鸣器；旁边的白色棕边部分是天线一体式的定位接收器；右上角的弹簧状模块是AIS的发射天线；右下的银色部分是集成了AIS的信号发射数据生成及处理的AIT33M模块。右下方是电源管理，底部是一个触点装置，浸水后自动开启并触发报警，手动也可通过按钮开启或关闭。长按按钮，听到“滴—滴—滴”三声后开机。此时，闪光灯闪烁，蜂鸣器开启，每60秒发一次信号。电子海图的屏幕上显示装置详细的接收时间，精确到秒，装置到了60秒左右会重新开始计时。再次长按按钮，三秒后便可关机。在测试模式中，此装置无需定位系统的支持，发射信号的程序号是MOB TEST。装置触发后，电子海图上会显现落水船舶的船速、航向、方位、行动轨迹等等基本信息。</p><p>如客户有合作制造AIS-MOB成品的需求，那么只需把电路板改成适配用户外壳的形状即可。</p>',
    date: '2023.07.05',
    des: '忆伯科技针对海上生命安全展示最新研发产品：AIS-MOB DEMO版。',
    cover: '/news/new9.png',
  },
  {
    id: 6,
    title: '忆伯科技参加深圳第六届中国国际无人系统博览会',
    content:
      '<p>6月2日至4日，2023第六届中国国际无人系统博览会暨第七届世界无人机大会（以下简称无人机展览会)，在深圳会展中心（福田）9号馆隆重举行。本届展会主题为“智绘天路、共赢未来”，来自50个国家及地区的400多家企业汇聚至此，参展专业观众约为31,000多名。</p><p>6月2日上午，展会正式开幕，现场一度火爆。无人机展览会是目前中国最大的无人机展会，聚集了无人机、智能汽车及机器人、无人系统综合、无人系统产业链等相关行业的供应商。</p><p>忆伯科技作为无人载具自动避碰方案商，积极参与其中，向同行展示自主研发的无人机、无人系统产品，包括：ADSR-800 无人机避碰；ADSR800 飞机外挂避碰；AIS112 无人机AIS数据采集、搜救模块；AIT33 无人机AIS示位标（无人船）。</p><p>其中，ADSR800 飞机外挂避碰作为本次展示的核心产品，具有高可靠性，其出色的外带抑制和nS级的捕获能力能够让体积小巧的它，帮助无人机在接受信号上灵活、高效地完成避碰工作。</p><p>本次展会同期进行了其他活动。例如，开展了无人机行业高峰论坛及赛事和自动驾驶、无人车与机器人论坛，为行业创造了多样赛道，成为企业间合作产业对接平台，打造消费类无人机生态图，推动国内外无人机新技术、新发展。</p><p>2021年，国务院在《国家综合立体交通网规划纲要》中首次提出发展低空经济，这为无人机行业在政策上提供了更多创新机遇和发展空间。中国经济正由高速增长向高质量发展转变，加速推动数字化技术与生产生活的全面渗透是必然趋势。</p><p>在展会期间，忆伯科技与国内外的业内人员进行深层次地交流，分享无人系统行业发展的最新动向，共同携手推动国内的无人机、无人系统的高质量发展并走向世界。</p><p>忆伯科技将继续在无人机、无人系统领域深挖行业痛点，满足客户定制需求，开发行业新打法，时刻跟随出台新政策的步伐，呼应行业新动向的号召。</p>',
    date: '2023.06.04',
    des: '无人机展会现场一度火爆，忆伯科技针对此次展会主要展示了公司自研的ADS-B模块，吸引众多专家咨询驻足洽谈。',
    cover: '/news/new8.png',
  },
  {
    id: 5,
    title: '忆伯科技获省级专精特新企业认证',
    content:
      '<p>2023年，忆伯科技荣获省级专精特新中小型企业资质。</p>2021年1月23日，财政部、工业和信息化部联合印发《关于支持“专精特新”中小企业高质量发展的通知》，启动中央财政支持“专精特新”中小企业高质量发展政策。强调以习近平新时代中国特色社会主义思想为指导，通过扶持专精特新企业、提升科技创新能力，构建服务“双循环”格局。</p><p>忆伯科技致力于开发高端技术，为客户提供基于物联网的软硬件技术服务和解决方案，紧跟习近平总书记关于“培育一批‘专精特新’中小企业”、提升中小企业创新能力的重要指示批示精神，与科技行业共同进步，注重产品的更新和质量，保证高效高质发展，不断创新，持续发展，为宝山科技添砖加瓦。</p>',
    date: '2023.04.03',
    des: '忆伯科技荣获省级专精特新中小型企业资质。',
    cover: '/news/cover4.jpeg',
  },
  {
    id: 4,
    title: '忆伯科技出席上海无人机协会大会',
    content:
      '<p>3月31日上午，上海市无人机安全管理协会召开第一届第四次会员大会暨第五次理事会、第四次监事会。 </p><p>忆伯科技受邀参加并参与《上海市无人机安全管理协会第一届第四次会员大会理事增补选举办法》和监票小组成员名单的投票。</p><p>本次会议对2022年协会完成的各项工作做出总结，同时对2023年的工作计划进行具体汇报。</p><p>为积极响应习近平总书记在首届中国国际进口博览会开幕式上关于长三角一体化发展上升为国家战略的讲话精神，牢牢把握新时代长三角一体化发展的历史机遇，上海市无人机安全管理协会与三省一市相关行业协会共同发起关于联合组建长三角无人机安全管理联络机制的倡议，立足于无人机安全管理，推动形成长三角地区合作联动。</p><p>展望2023年，将是充满机遇和挑战的一年，忆伯科技将与协会、同行齐头并进，一同推动无人机行业安全、有序、健康、高效发展。',
    date: '2023.03.31',
    des: '忆伯科技受邀出席大会，一同推动无人机行业安全和高效发展。',
    cover: '/news/cover5.jpeg',
  },
  {
    id: 3,
    title: '区镇领导来访忆伯科技参观交流',
    content:
      '<p>2023年3月29日，上海市宝山区杨行镇镇领导来访忆伯科技参观交流</p><p>调研期间，忆伯科技董事长徐伯胜通过数字大屏和硬件产品结合的方式，向一行领导介绍忆伯科技的产品设备的性能、行业应用情况和发展方向。</p><p>此次走访考察凸显了镇党委镇政府对企业的重视和关注。</p><p>党委副书记、镇长杨文杰对忆伯科技的成果表示肯定，对忆伯科技的工作做出指导，希望未来忆伯科技在专业化发展的道路上不断奋进，为科技创新领域继续做出贡献。',
    date: '2023.03.29',
    des: '董事长徐伯胜向上海市杨行镇镇领导介绍公司情况。',
    cover: '/news/cover2.jpeg',
  },
  {
    id: 2,
    title: '忆伯科技与有人物联达成战略合作',
    content:
      '<p>2021年6月1日，济南有人物联网董事长古欣接待了忆伯科技董事长徐伯胜一行，双方对公司的发展方向以及相关合作事宜进行深入沟通，成功签署战略合作协议，并达成战略合作。</p><p>山东有人物联网股份有限公司：定位“可信赖的智慧工业物联网伙伴”，以“连接价值、价值连接”为使命，专注于通讯产品的研发、生产及销售，是业内领先的工业物联网软硬件解决方案服务商。</p><p>忆伯科技与有人物联网以科技创新赋能，发挥双方优势资源，夯实合作内容，一同致力于为客户提供云平台服务、物联网等解决方案。',
    date: '2022.06.01',
    des: '忆伯科技与济南有人物联网成功签署战略合作协议，达成战略合作。',
    cover: '/news/cover1.jpeg',
  },
  {
    id: 1,
    title: '宝山区区委领导一行莅临忆伯科技',
    content:
      '<p>2021年11月25日上午，上海市宝山区区委常委，宣传部胡宝国部长一行莅临指导忆伯科技。忆伯科技董事长首先向调研组介绍了公司经营现状、发展规划、核心技术、资质荣誉、人才队伍等情况。领导充分肯定了忆伯科技近几年来所取得的成绩，并表示忆伯科技是一个快速发展，且有梦想、有追求、有规划的企业。</p><p>随后与公司管理层探讨了忆伯科技在发展过程中所存在的问题，并同时就政府对高精尖技术企业的政策扶持和进一步加强政企合作做了简要的介绍。</p> <p> 最后，董事长对领导们的莅临指导表示感谢，并表示忆伯科技将继续发扬“技术驱动，业务支撑，行业沉淀”的基本思想，以“快速响应，联勤联动”的企业准则，在神经元感知端的深度开发和大数据应用创新等领域取得更大的突破。',
    date: '2021.11.25',
    des: '2021年11月25日，宝山区区委常委宣传部领导一行莅临指导忆伯科技。',
    cover: '/news/new7.jpg',
  },
]
